// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:09.673Z
// Property: Chimneys Apts. (ID: 6767906449165592)
// Collections: 31 amenities, 5 floorplans (live), 40 photos, 68 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165592",
  "property_external_id": "f2p1xxt",
  "property_zillow_url": "https://www.zillow.com/homedetails/200-N-Festival-Dr-El-Paso-TX-79912/27411504_zpid/",
  "property_apartments_url": "https://www.apartments.com/chimneys-apts-el-paso-tx/f2p1xxt/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Chimneys+Apartments/data=!4m2!3m1!1s0x0:0x56e26bcb8db35795?sa=X&ved=2ahUKEwjU8rOv9LySAxVoCnkGHe9lFEUQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "chimneys-apts",
  "property_name": "Chimneys Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/chimneys-apts/",
  "property_domain": null,
  "property_address": "200 N. Festival",
  "property_full_address": "200 N. Festival, El Paso, TX, 79912",
  "property_address_1": "200 N. Festival",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79912",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Festival Hills",
  "property_address_latitude": "31.8196",
  "property_address_longitude": "-106.5109",
  "property_email": "chimneys@caseusa.com",
  "property_phone": "(915) 284-8909",
  "property_call_tracking_phone": "855-957-4271",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Chimneys Apts. in sunny El Paso, where modern living meets comfort. Choose from spacious one and two-bedroom floor plans, and enjoy exceptional amenities like a refreshing pool, fitness center, and pet-friendly spaces. Elevate your lifestyle in our vibrant community—check availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Chimneys Apartments, your ultimate oasis in El Paso, Texas! Discover our thoughtfully designed one and two-bedroom floor plans, perfect for anyone looking for luxury and comfort. Each apartment includes modern amenities such as air conditioning, high-speed internet access, and spacious walk-in closets that make everyday living a breeze. \n\nAt Chimneys Apartments, every day feels like a vacation. Enjoy a refreshing dip in our sparkling pool or stay fit at our fully equipped fitness center. Socialize with neighbors in our inviting clubhouse or take advantage of our convenient package service for your online orders. For pet lovers, our pet play area and dog park ensure your furry friends have plenty of space to roam and play.\n\nWe understand the importance of convenience, which is why we offer 24-hour access, on-site maintenance, and property management to ensure all your needs are met. With additional amenities like laundry facilities, a business center, and a recreation room, Chimneys Apartments is designed to enrich your lifestyle. Relax outdoors in our picnic area complete with grills or unwind on your private balcony or patio, ideal for enjoying the El Paso sunshine.\n\nLocated near public transportation, Chimneys Apartments provides easy access to all that El Paso has to offer. Don’t miss out on this exceptional living experience—find your new home today! Browse our availability or schedule a tour to visit our community and see all that Chimneys Apartments has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019fb44b-406a-7587-807f-492f3abc4562.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings nestled against a mountain backdrop.",
    "public_id": "019fb44b-406a-7587-807f-492f3abc4562",
    "storage_key": "property/6767906449165592/019fb44b-406a-7587-807f-492f3abc4562.webp",
    "width": 1280,
    "height": 852
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "224",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.10714285714286",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Contact Leasing Office for details",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://chimneysapartmentselpaso.securecafe.com/onlineleasing/chimneys-apts/floorplans.aspx",
  "property_resident_portal_url": "https://chimneysapartmentselpaso.securecafe.com/residentservices/chimneys-apts/userlogin.aspx",
  "property_apply_now_url": "https://chimneysapartmentselpaso.securecafe.com/onlineleasing/chimneys-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3a-e7b6-76a8-8744-14bceb05c165.webp",
  "property_primary_logo_media": {
    "alt_text": "The Chimneys Apartments logo",
    "public_id": "019cfb3a-e7b6-76a8-8744-14bceb05c165",
    "storage_key": "property/6767906449165592/019cfb3a-e7b6-76a8-8744-14bceb05c165.webp",
    "width": 300,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3c-9208-7377-b27e-40f7f5758b49.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb3c-9208-7377-b27e-40f7f5758b49",
    "storage_key": "property/6767906449165592/019cfb3c-9208-7377-b27e-40f7f5758b49.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3c-c831-7120-908e-16ad912f027c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Chimneys Apartments Logo",
    "public_id": "019cfb3c-c831-7120-908e-16ad912f027c",
    "storage_key": "property/6767906449165592/019cfb3c-c831-7120-908e-16ad912f027c.webp",
    "width": 300,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3c-ce9e-715e-8887-a9a45670ff11.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Chimneys Apartments logo.",
    "public_id": "019cfb3c-ce9e-715e-8887-a9a45670ff11",
    "storage_key": "property/6767906449165592/019cfb3c-ce9e-715e-8887-a9a45670ff11.webp",
    "width": 300,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#9b6e64",
  "property_secondary_color": "#c0b1a1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "800 - 800",
  "property_sqft_min": "800",
  "property_sqft_max": "800",
  "property_price_range": "1329 - 1329",
  "property_price_min": "1329",
  "property_price_max": "1329",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/chimneysapartments/posts/at-the-chimneys-our-1-and-2-bedroom-apartments-in-el-paso-are-designed-for-easy-/1487073550092794/",
  "property_instagram_url": "https://www.instagram.com/chimneys_apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ84B2rZJX54YRlVezjctr4lY",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-chimneys-apartments-el-paso-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Chimneys Apts.",
  "property_home_romance_title": "Embrace Life in Your Ideal Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Chimneys Apartments in vibrant El Paso, Texas, where comfort meets convenience. Choose from our spacious one and two-bedroom floor plans, enjoy amenities like a sparkling pool, fitness center, and dog park. With 24-hour access and online services, your ideal lifestyle awaits. Embrace community living at its finest!",
  "property_home_floorplans_blurb": "At Chimneys Apts. in vibrant El Paso, Texas, choose from spacious one and two-bedroom floor plans that perfectly suit your lifestyle. Each residence blends comfort with style, offering an inviting sanctuary to call home. Ready to elevate your living experience? Browse our available apartments to find your ideal match today!",
  "property_home_gallery_blurb": "At Chimneys Apts. in El Paso, immerse yourself in comfort with spacious one and two-bedroom floor plans. Enjoy luxurious amenities like a refreshing pool, state-of-the-art fitness center, and inviting social spaces. Picture lounging on your balcony or walking your dog in our pet-friendly park—your perfect home awaits!",
  "property_home_neighborhood_blurb": "Welcome to Chimneys Apartments in vibrant El Paso, Texas, where comfort meets convenience. Choose from spacious one or two-bedroom layouts, all situated near key educational landmarks like UT El Paso and El Paso Community College campuses. Uncover the enriching amenities and local charm surrounding our community today!",
  "property_home_reviews_blurb": "At Chimneys Apts. in El Paso, residents rave about the vibrant community atmosphere and exceptional service, with one saying, “The staff makes you feel right at home.” Experience the perfect blend of comfort and convenience. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Chimneys Apts. in El Paso, discover a vibrant community surrounded by educational excellence. With one and two-bedroom floor plans, you’ll enjoy proximity to UT El Paso, El Paso Community College campuses, and top-tier schools like Green Elementary and Coronado High School. Experience a neighborhood ripe with opportunity!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Chimneys Apts. in El Paso, experience a vibrant lifestyle with our inviting pool, modern fitness center, and dog park. Enjoy conveniences like online services and on-site maintenance, all set within stylish apartments tailored for comfort. Your perfect home awaits—check out our exceptional amenities today!",
  "property_applynow_blurb": "At Chimneys Apts. in vibrant El Paso, your ideal escape awaits. Choose from stylish one or two-bedroom floor plans featuring modern amenities like a refreshing pool, a state-of-the-art fitness center, and a cozy clubhouse. Embrace comfort with spacious walk-in closets, air conditioning, and online leasing convenience. Your new home is just a click away!",
  "property_contactus_blurb": "At Chimneys Apts. in El Paso, Texas, you'll find thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Whether you crave cozy solitude or extra space for entertaining, we have the perfect layout for you. Have questions? Contact our leasing team today to learn more!",
  "property_faqs_blurb": "At Chimneys Apts. in vibrant El Paso, Texas, we offer stylish one and two-bedroom floor plans tailored to your lifestyle. Whether you’re seeking cozy solitude or spacious living, we have the perfect home for you. For clarity on your new community, browse our FAQs page for answers to common inquiries.",
  "property_floorplans_blurb": "At Chimneys Apts. in vibrant El Paso, Texas, your ideal living space awaits. Choose from stylish one or two-bedroom floor plans designed for comfort and convenience. Dive into a world of possibilities and unveil the apartment home that perfectly aligns with your lifestyle. Browse our options today!",
  "property_gallery_blurb": "At Chimneys Apts. in El Paso, Texas, vibrant living meets comfort. Choose from stylish one or two-bedroom floor plans while enjoying amenities like a refreshing pool, fitness center, and a welcoming dog park. Picture yourself unwinding on your private patio or gathering with friends in our charming clubhouse!",
  "property_interactivemap_blurb": "At Chimneys Apts. in vibrant El Paso, Texas, our one and two-bedroom floor plans offer the perfect blend of comfort and style. Enjoy resort-style amenities like a refreshing pool, fitness center, and inviting dog park. Use our interactive community map to find your ideal apartment today and experience urban living redefined!",
  "property_pets_blurb": "At Chimneys Apartments in El Paso, TX, your furry friends are part of the family! Enjoy pet-friendly living in a vibrant community, where comfort meets convenience. With spacious floor plans and inviting amenities, your new home is just a paw print away. Reach out to the leasing office for details!",
  "property_referafriend_blurb": "At Chimneys Apts. in El Paso, Texas, we offer inviting one and two-bedroom floor plans designed for comfort and style. Great friends enhance every living experience—refer a friend to our vibrant community today and build cherished memories together in your new home! Great neighbors start with great friends!",
  "property_residentaccess_blurb": "Welcome to Chimneys Apts. in El Paso, where comfort meets convenience! Our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Access your resident portal with ease to pay rent, schedule maintenance, and enjoy all the perks of community living. Your ideal home awaits!",
  "property_reviews_blurb": "At Chimneys Apts. in El Paso, residents rave about the welcoming atmosphere, stating, “The sense of community here is incredible.” Join a vibrant neighborhood that feels like home—check out our reviews to see what makes living here so special and why our residents love calling Chimneys Apts. their home!",
  "property_created_at": "1753982379973",
  "property_scheduletour_blurb": "At Chimneys Apts. in vibrant El Paso, Texas, choose from our thoughtfully designed one and two-bedroom floor plans, tailored for your lifestyle. Experience the warmth of community living and vibrant surroundings. Ready to find your perfect home? Schedule a tour today and hear firsthand from our happy residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Chimneys Apts. in vibrant El Paso! Our inviting one and two-bedroom floor plans promise a tailored living experience. A team member will be in touch soon to help you find the perfect home that fits your lifestyle and needs. Stay tuned for more information!",
  "property_virtualtours_blurb": "Welcome to Chimneys Apts. in vibrant El Paso, Texas! Choose from spacious one- and two-bedroom floor plans that cater to your lifestyle. Immerse yourself in our community’s unique charm by taking a virtual tour of our apartments for rent—your new adventure awaits just a click away!",
  "property_copyright": "2025 All Rights Reserved. Chimneys Apts.",
  "property_seo_title_home": "Chimneys Apts. |  Apartments in El Paso, Texas",
  "property_seo_description_home": "Embrace comfort at Chimneys Apts. in El Paso! Enjoy spacious layouts, top-notch amenities, and a vibrant community. Your ideal home awaits—join us today!",
  "property_seo_title_floorplans": "Floor Plans | El Paso, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Chimneys Apts. in El Paso! Check out our unique one and two-bedroom floor plans designed for comfort and style. Your new space awaits!",
  "property_seo_title_amenities": "Amenities | El Paso, Texas Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Chimneys Apts. in El Paso! Enjoy a pet-friendly haven with a pool, fitness center, and cozy, modern apartments. Check us out!",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, Texas",
  "property_seo_description_gallery": "Envision your life at Chimneys Apts. in El Paso! With inviting floor plans, top-notch amenities, and scenic views, find your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Chimneys Apts. Apartments",
  "property_seo_description_virtualtours": "Step into comfort at Chimneys Apts. in El Paso! Take a virtual tour of our inviting one and two-bedroom apartments and envision your new home today.",
  "property_seo_title_interactivemap": "Interactive Map | Chimneys Apts. Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Chimneys Apts. in El Paso! Explore our interactive map for diverse floor plans and amenities today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, Texas",
  "property_seo_description_neighborhood": "Uncover the charm of El Paso near Chimneys Apts. with vibrant neighborhoods, local favorites, and must-see attractions just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Chimneys Apts.",
  "property_seo_description_contact": "Connect with the Chimneys Apts. team in El Paso! Inquiries welcome about our spacious one and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, Texas",
  "property_seo_description_faqs": "Find quick answers to your questions about Chimneys Apts. in El Paso. Explore our amenities, floor plans, and everything our community has to offer!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, Texas",
  "property_seo_description_reviews": "Experience life at Chimneys Apts. in El Paso! Read resident reviews and see why our community is the perfect blend of comfort, amenities, and accessibility.",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, Texas",
  "property_seo_description_applynow": "Embrace comfort and style at Chimneys Apts. in El Paso! From spacious floor plans to premium amenities, your ideal home awaits. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Chimneys Apts.",
  "property_seo_description_residentaccess": "Unlock convenience at Chimneys Apts. in El Paso! Access your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Chimneys Apts.",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Chimneys Apts in El Paso and enjoy a vibrant community together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chimneys Apts.",
  "property_seo_description_scheduletour": "Experience comfort at Chimneys Apts. in El Paso. Schedule your tour today and envision your new home in our vibrant community filled with modern amenities!",
  "property_seo_title_privacy": "Privacy Policy | Chimneys Apts.",
  "property_seo_description_privacy": "Your privacy matters at Chimneys Apts. in El Paso! Safeguarding your information is our priority. View our privacy policy for peace of mind today.",
  "property_seo_title_accessibility": "Website Accessibility | Chimneys Apts.",
  "property_seo_description_accessibility": "At Chimneys Apts. in El Paso, we prioritize accessibility for all. Join a community where everyone feels at home. Your inclusive living experience awaits!",
  "property_seo_title_sitemap": "Sitemap | Chimneys Apts.",
  "property_seo_description_sitemap": "Uncover every corner of Chimneys Apts. in El Paso, Texas! Check out our sitemap to navigate your way to your new home and community offerings.",
  "property_seo_title_thankyou": "Thank You | Chimneys Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out! We appreciate your interest in Chimneys Apts. in El Paso. Our team will connect with you soon to assist with your new home journey.",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864969874",
  "amenities": [
    {
      "id": "ec_534b2abbd259d0aa81740fdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396334",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e50bc11b10292e74c02438b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396335",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fb80e5ac6c3396d8ee905a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396336",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77e8baaf019ac2184ead02e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396337",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3cfcdbbeb3a2d3cb528722c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396338",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bee0f088d4030cc72f65834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396339",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac5a1764b217ec9ddb079bd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396340",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_768d191bf649475b535d64ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396342",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e196273650cd690d44e8fb02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396343",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_299bd16e3651617b67802f22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396344",
      "title": "Beautiful Mountain Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3964913feb489a7fc0aabf98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396345",
      "title": "Exterior Storage Closet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5526300d39eaa086ec959e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396346",
      "title": "Ideal Location Near Fort Bliss",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7cf83a18171e031df5f21595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396347",
      "title": "Outdoor Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fe42109281971969ec343ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396348",
      "title": "Close to I-10",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1254a024a1efe2f4f5781888",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396349",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b9f49f4b6583495aa177bee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396350",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_089a618cdb7bd2237c59c17b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396351",
      "title": "Online Rental Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de86aabcf1617c8505adc073",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396352",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a29554bc73a87b1ab21dae1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127396353",
      "title": "Onsite Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98aa72189d339bab13e93f3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397844",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c5efc7d268d5c5bc4595e39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397845",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b18c42d9a1b92fcd4e648cf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397846",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_910c0aeab85de6979a2417b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397847",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c2adb4c4301eb757b1727e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397848",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e68e08a251096c6a125749fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397849",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67c7e02c71e27c9f55164da2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397850",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5868830d53e48317c6d30f3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397851",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_448fbe4e8b94b3c4f34e6578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397852",
      "title": "Fully Equipped Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6b731461cccec2319384519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397853",
      "title": "Dry Bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_631a24efb535417717b6088f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397854",
      "title": "Roommate Friendly Floorplan*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9314635ccc2bfbbd5c781543",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "yardi",
      "external_id": "127397855",
      "title": "Get connected to internet powered by Spectrum",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_9833fbaa-e14f-4343-8eb3-2adba4e8051d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-98cb-7359-ac42-e299c1813e0a.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sofa, armchair, coffee table, and dining set.",
        "public_id": "019f611e-98cb-7359-ac42-e299c1813e0a",
        "storage_key": "property/6767906449165592/019f611e-98cb-7359-ac42-e299c1813e0a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, accent armchair, and a stylish dining set, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living and dining area with a sofa, armchair, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cff91323-3d96-464f-aa24-048c8c82ed49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-516f-7518-a5f1-77d7ea8b5847.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex nestled against a mountain range.",
        "public_id": "019f611e-516f-7518-a5f1-77d7ea8b5847",
        "storage_key": "property/6767906449165592/019f611e-516f-7518-a5f1-77d7ea8b5847.webp",
        "width": 2700,
        "height": 1799
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment community, ideally situated with stunning mountain views. Experience the perfect blend of nature and convenience.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex nestled against a mountain range.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4aef906b-93cb-4ad4-903c-0d960935ecc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-b163-7289-824b-8e87382097a4.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a marble countertop.",
        "public_id": "019f611e-b163-7289-824b-8e87382097a4",
        "storage_key": "property/6767906449165592/019f611e-b163-7289-824b-8e87382097a4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a white bathtub and toilet, a wood-grain vanity with a marble countertop, and decorative wall art.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2fd0b3e-abaf-4450-b719-26faeed0f683",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-c4da-724d-8a1e-db1c6da55313.webp",
      "image_media": {
        "alt_text": "Clean white bathtub and toilet with dark wood floors.",
        "public_id": "019f611e-c4da-724d-8a1e-db1c6da55313",
        "storage_key": "property/6767906449165592/019f611e-c4da-724d-8a1e-db1c6da55313.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a white bathtub, toilet, and tiled walls, with stylish dark wood flooring and decorative accents.",
      "link": "",
      "alt_text": "Clean white bathtub and toilet with dark wood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1c48979-1909-4735-bf02-1507d6599153",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-b94a-71af-8cf9-6db28818ab71.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, decorative pillows, and a ceiling fan.",
        "public_id": "019f611e-b94a-71af-8cf9-6db28818ab71",
        "storage_key": "property/6767906449165592/019f611e-b94a-71af-8cf9-6db28818ab71.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, elegant decor, and a soothing ambiance.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, decorative pillows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d08b6b9-6825-462d-88c2-ebdc2e5b5717",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-c53a-7215-ac6f-3e2c34eba21a.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelving and a clothing rod.",
        "public_id": "019f611e-c53a-7215-ac6f-3e2c34eba21a",
        "storage_key": "property/6767906449165592/019f611e-c53a-7215-ac6f-3e2c34eba21a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with built-in shelving and a clothing rod, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelving and a clothing rod.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d2b2b58-3b02-4437-a932-72ed6734efaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-c59c-761c-ac62-4e125c308e2f.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, plush pillows, and a decorative wall accent.",
        "public_id": "019f611e-c59c-761c-ac62-4e125c308e2f",
        "storage_key": "property/6767906449165592/019f611e-c59c-761c-ac62-4e125c308e2f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush queen-sized bed and tasteful decor for a peaceful retreat.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, plush pillows, and a decorative wall accent.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c747cb9-bebc-4081-a1a0-3b8f57aceabe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-c220-724b-a0ab-bed89489ec92.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dual sinks and wooden cabinets, leading to a bathtub and shower.",
        "public_id": "019f611e-c220-724b-a0ab-bed89489ec92",
        "storage_key": "property/6767906449165592/019f611e-c220-724b-a0ab-bed89489ec92.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with a granite countertop, wooden cabinetry, and a separate bathtub and shower area.",
      "link": "",
      "alt_text": "Bathroom vanity with dual sinks and wooden cabinets, leading to a bathtub and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2076ccbb-5c2c-4fa1-8ac1-837abdb2e210",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-b3a5-74fe-9583-b0aa3177d814.webp",
      "image_media": {
        "alt_text": "Balcony with view of trees",
        "public_id": "019f611e-b3a5-74fe-9583-b0aa3177d814",
        "storage_key": "property/6767906449165592/019f611e-b3a5-74fe-9583-b0aa3177d814.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious balcony overlooking lush green trees. Enjoy your morning coffee or evening breeze in this private outdoor space.",
      "link": "",
      "alt_text": "Balcony with view of trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbeff5ef-16d5-4916-8609-1d943cd65ca5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-af17-71ec-85ec-f84eb88008e5.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelving and clothing rods.",
        "public_id": "019f611e-af17-71ec-85ec-f84eb88008e5",
        "storage_key": "property/6767906449165592/019f611e-af17-71ec-85ec-f84eb88008e5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelving and clothing rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29dac74e-b287-4823-954a-c2b8fa2da418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-9540-70fe-8d56-60194a1a8c8f.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, dining area, and view into a bedroom.",
        "public_id": "019f611e-9540-70fe-8d56-60194a1a8c8f",
        "storage_key": "property/6767906449165592/019f611e-9540-70fe-8d56-60194a1a8c8f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy brick fireplace, a dedicated dining space, and a glimpse into a comfortable bedroom, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, dining area, and view into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a9d1c287-ff06-4460-a464-f62e0586a976",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-a945-7750-b507-48492796d68e.webp",
      "image_media": {
        "alt_text": "Bedroom with two beds, a ceiling fan, and a large window.",
        "public_id": "019f611e-a945-7750-b507-48492796d68e",
        "storage_key": "property/6767906449165592/019f611e-a945-7750-b507-48492796d68e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring two cozy beds, a ceiling fan for comfort, and a large window with a view of the outdoors. Perfect for guests or a shared space.",
      "link": "",
      "alt_text": "Bedroom with two beds, a ceiling fan, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_814f5f24-f35c-4ec9-a80a-6c0336aca8e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-9986-7668-b61a-61b3608698ff.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances and wooden cabinets.",
        "public_id": "019f611e-9986-7668-b61a-61b3608698ff",
        "storage_key": "property/6767906449165592/019f611e-9986-7668-b61a-61b3608698ff.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A well-equipped kitchen featuring a white refrigerator, stove, and microwave, complemented by rich wooden cabinetry.",
      "link": "",
      "alt_text": "Kitchen with white appliances and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_464d0e47-a94c-417f-8e83-17de2679722b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-9bca-70cc-b6eb-1d6d8d86a8d2.webp",
      "image_media": {
        "alt_text": "Galley kitchen with wooden cabinets, stainless steel sink, and white appliances.",
        "public_id": "019f611e-9bca-70cc-b6eb-1d6d8d86a8d2",
        "storage_key": "property/6767906449165592/019f611e-9bca-70cc-b6eb-1d6d8d86a8d2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern galley kitchen featuring rich wooden cabinetry, a double stainless steel sink, and ample counter space. Includes essential appliances and a window for natural light.",
      "link": "",
      "alt_text": "Galley kitchen with wooden cabinets, stainless steel sink, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ecf9f91-0b05-410b-971d-b086181e80cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-992b-730e-b0b3-c2d529e56fdd.webp",
      "image_media": {
        "alt_text": "Dining area with a fireplace and a large window.",
        "public_id": "019f611e-992b-730e-b0b3-c2d529e56fdd",
        "storage_key": "property/6767906449165592/019f611e-992b-730e-b0b3-c2d529e56fdd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy dining area featuring a wood table set for four, a brick fireplace, and a decorative wall art.",
      "link": "",
      "alt_text": "Dining area with a fireplace and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f2d3136c-a8e0-4cc2-8f5b-e21bbb2730e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-97e1-74b0-8dff-5efd3c1fb3e1.webp",
      "image_media": {
        "alt_text": "Cozy living room with a brick fireplace, leather couch, and coffee table.",
        "public_id": "019f611e-97e1-74b0-8dff-5efd3c1fb3e1",
        "storage_key": "property/6767906449165592/019f611e-97e1-74b0-8dff-5efd3c1fb3e1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in your spacious living room, complete with a charming brick fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Cozy living room with a brick fireplace, leather couch, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f56b0736-d6dd-4572-a3cb-d1788601429f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-91ce-74ea-b78c-472fc5fd47fa.webp",
      "image_media": {
        "alt_text": "Balcony view with trees and a closed door",
        "public_id": "019f611e-91ce-74ea-b78c-472fc5fd47fa",
        "storage_key": "property/6767906449165592/019f611e-91ce-74ea-b78c-472fc5fd47fa.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony with a scenic view of the surrounding trees and landscape. Includes convenient storage closet.",
      "link": "",
      "alt_text": "Balcony view with trees and a closed door",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c5879fa-4a5f-478e-b2d2-2d6089163b60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-6e23-7696-8474-b6fc3c2a8015.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, microwave, and stove.",
        "public_id": "019f611e-6e23-7696-8474-b6fc3c2a8015",
        "storage_key": "property/6767906449165592/019f611e-6e23-7696-8474-b6fc3c2a8015.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "View of a modern apartment kitchen featuring dark wood cabinets, a white stove and refrigerator, and a microwave.",
      "link": "",
      "alt_text": "Kitchen with white refrigerator, microwave, and stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63fc694e-5698-4b47-9793-38f1938e7365",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-7d2f-7269-bd35-e1354accfdb7.webp",
      "image_media": {
        "alt_text": "Bedroom with tufted headboard, white bedding, and a ceiling fan.",
        "public_id": "019f611e-7d2f-7269-bd35-e1354accfdb7",
        "storage_key": "property/6767906449165592/019f611e-7d2f-7269-bd35-e1354accfdb7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom. Features a spacious bed with a luxurious tufted headboard, soft white linens, and a ceiling fan for optimal comfort.",
      "link": "",
      "alt_text": "Bedroom with tufted headboard, white bedding, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31038598-47a5-4e49-bd3e-1279b2040b06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-503a-760a-8728-1d97ce4c3c09.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washing machines and dryers.",
        "public_id": "019f611e-503a-760a-8728-1d97ce4c3c09",
        "storage_key": "property/6767906449165592/019f611e-503a-760a-8728-1d97ce4c3c09.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "On-site laundry facilities equipped with multiple washers and dryers for resident convenience.",
      "link": "",
      "alt_text": "Laundry room with rows of washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_29149012-b148-4436-b9ba-934d0b1201d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-711e-75db-8549-ecbc04b8ce53.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, dishwasher, and refrigerator.",
        "public_id": "019f611e-711e-75db-8549-ecbc04b8ce53",
        "storage_key": "property/6767906449165592/019f611e-711e-75db-8549-ecbc04b8ce53.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample cabinet space, granite countertops, a double sink, and essential appliances for a convenient living experience.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, granite countertops, stainless steel sink, dishwasher, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e01aea26-b193-4ac6-9d10-773f9c62fad1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-7234-746f-9fd2-720fa125e6b7.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, and stainless steel sink.",
        "public_id": "019f611e-7234-746f-9fd2-720fa125e6b7",
        "storage_key": "property/6767906449165592/019f611e-7234-746f-9fd2-720fa125e6b7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A galley-style kitchen featuring dark wood cabinetry, granite countertops, stainless steel sink, dishwasher, refrigerator, and a white oven with stovetop.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_247470e4-793c-41a0-8b62-47ace9776dcf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-505d-7129-9c6b-3dcd0f5c6b05.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee tables, a wet bar, and a decorative armchair.",
        "public_id": "019f611e-505d-7129-9c6b-3dcd0f5c6b05",
        "storage_key": "property/6767906449165592/019f611e-505d-7129-9c6b-3dcd0f5c6b05.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, stylish coffee tables, a fully equipped wet bar with a mirrored backsplash, and a unique armchair, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a couch, coffee tables, a wet bar, and a decorative armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f33d84c2-0bfd-4ee1-84c3-0903e7851581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-52de-739f-9674-c28873645d03.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a mountain backdrop.",
        "public_id": "019f611e-52de-739f-9674-c28873645d03",
        "storage_key": "property/6767906449165592/019f611e-52de-739f-9674-c28873645d03.webp",
        "width": 2700,
        "height": 1799
      },
      "title": "Community",
      "description": "Spacious apartment complex nestled against a scenic mountain range, offering a blend of comfortable living and natural beauty.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a mountain backdrop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f752cca-0b17-4b27-a069-1cbee48d27c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-51a7-7148-9069-894ed154743a.webp",
      "image_media": {
        "alt_text": "Living room with a wet bar, sofa, and cow print accent chair.",
        "public_id": "019f611e-51a7-7148-9069-894ed154743a",
        "storage_key": "property/6767906449165592/019f611e-51a7-7148-9069-894ed154743a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a wet bar, plush sofa, and a unique cow print accent chair, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a wet bar, sofa, and cow print accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21a6d45b-3f4f-492e-867b-aa891313ece6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-5063-7460-a077-445feac82751.webp",
      "image_media": {
        "alt_text": "Laundry room with washers and dryers, exterior view through window.",
        "public_id": "019f611e-5063-7460-a077-445feac82751",
        "storage_key": "property/6767906449165592/019f611e-5063-7460-a077-445feac82751.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with washers and dryers. Enjoy the ease of doing laundry without leaving the property.",
      "link": "",
      "alt_text": "Laundry room with washers and dryers, exterior view through window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_03c71236-57bf-47d3-8af0-09eabfc24b62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611d-dd03-777d-9f4f-50edbae21594.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, and free weights",
        "public_id": "019f611d-dd03-777d-9f4f-50edbae21594",
        "storage_key": "property/6767906449165592/019f611d-dd03-777d-9f4f-50edbae21594.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, weight machines, and free weights for residents to stay active.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, and free weights",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bfc362f0-acb9-44d2-9bf3-077d5a141b65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611d-daef-7179-932b-a855af0111f2.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and ellipticals",
        "public_id": "019f611d-daef-7179-932b-a855af0111f2",
        "storage_key": "property/6767906449165592/019f611d-daef-7179-932b-a855af0111f2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, elliptical machines, and weight equipment for residents.",
      "link": "",
      "alt_text": "Fitness center with treadmills and ellipticals",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc703c04-88a4-43ae-bdbd-4d2de37394ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611d-db2c-706c-8350-d26ec3143be2.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, and weight equipment.",
        "public_id": "019f611d-db2c-706c-8350-d26ec3143be2",
        "storage_key": "property/6767906449165592/019f611d-db2c-706c-8350-d26ec3143be2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, strength training equipment, and free weights for residents to enjoy.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, and weight equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28cb118e-cd5c-4e34-ac0f-933be4429037",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-4cc3-71f8-be47-64cd17e3d275.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with brick and beige siding, parking lot, and landscaping under a blue sky.",
        "public_id": "019f611c-4cc3-71f8-be47-64cd17e3d275",
        "storage_key": "property/6767906449165592/019f611c-4cc3-71f8-be47-64cd17e3d275.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Discover the charming exteriors of our apartment community. This building features a mix of brick and siding, surrounded by mature landscaping and convenient parking.",
      "link": "",
      "alt_text": "Exterior view of an apartment building with brick and beige siding, parking lot, and landscaping under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c2695c6-1957-4d3a-bd92-bcff329cb78c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-2e66-76a3-99b4-ce0bc95e9ce4.webp",
      "image_media": {
        "alt_text": "The Chimneys Apartments monument sign with address 200 and phone number 915-584-4323.",
        "public_id": "019f611c-2e66-76a3-99b4-ce0bc95e9ce4",
        "storage_key": "property/6767906449165592/019f611c-2e66-76a3-99b4-ce0bc95e9ce4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to The Chimneys Apartments, featuring comfortable living spaces and a convenient location. Call us today at 915-584-4323 to learn more.",
      "link": "",
      "alt_text": "The Chimneys Apartments monument sign with address 200 and phone number 915-584-4323.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a991f184-1392-4b8a-a713-bfdf05dd3a69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-3cf0-752a-a24d-32e4b84ea9b9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with brick facade and balconies.",
        "public_id": "019f611c-3cf0-752a-a24d-32e4b84ea9b9",
        "storage_key": "property/6767906449165592/019f611c-3cf0-752a-a24d-32e4b84ea9b9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of the apartment building, showcasing its red brick exterior and private balconies.",
      "link": "",
      "alt_text": "Exterior view of apartment building with brick facade and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b56f7e03-e0a0-49b0-8d2a-56dd2b1782e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-4a42-70fd-b0bb-be24dc682883.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and brick accents, surrounded by landscaping and gravel pathways.",
        "public_id": "019f611c-4a42-70fd-b0bb-be24dc682883",
        "storage_key": "property/6767906449165592/019f611c-4a42-70fd-b0bb-be24dc682883.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring attractive brickwork and private balconies, set within a beautifully landscaped community with decorative gravel paths.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and brick accents, surrounded by landscaping and gravel pathways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e890db48-82b8-4ed3-8880-a9ee9812028d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-24d6-764a-b073-0d853c7e2e74.webp",
      "image_media": {
        "alt_text": "Reception desk area with two desks, chairs, and decor.",
        "public_id": "019f611c-24d6-764a-b073-0d853c7e2e74",
        "storage_key": "property/6767906449165592/019f611c-24d6-764a-b073-0d853c7e2e74.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our leasing office! Our friendly team is ready to assist you with finding your perfect apartment home.",
      "link": "",
      "alt_text": "Reception desk area with two desks, chairs, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2eade09b-0d16-40bd-bc7f-939d79f405a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-28cf-7273-893f-31dd1e17314a.webp",
      "image_media": {
        "alt_text": "Multifamily property office reception desk with computer and chairs.",
        "public_id": "019f611c-28cf-7273-893f-31dd1e17314a",
        "storage_key": "property/6767906449165592/019f611c-28cf-7273-893f-31dd1e17314a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our leasing office! Meet with our friendly staff at the reception desk, equipped with a computer and seating for visitors.",
      "link": "",
      "alt_text": "Multifamily property office reception desk with computer and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de40fb17-1a3a-4ba6-87f3-e0b7568f9986",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-15cb-7500-9938-c512b953af7a.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool and spa with fountains, lounge chairs, and apartment buildings in the background.",
        "public_id": "019f611c-15cb-7500-9938-c512b953af7a",
        "storage_key": "property/6767906449165592/019f611c-15cb-7500-9938-c512b953af7a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor pool and spa area, complete with fountains and comfortable lounge seating.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool and spa with fountains, lounge chairs, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_787feff5-049e-4387-af64-c46c5b914ee7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-0f98-737a-96a0-c03b0d3fa4b8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and spa area with fountains and seating.",
        "public_id": "019f611c-0f98-737a-96a0-c03b0d3fa4b8",
        "storage_key": "property/6767906449165592/019f611c-0f98-737a-96a0-c03b0d3fa4b8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful outdoor swimming pool and spa area, complete with soothing fountains and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool and spa area with fountains and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f5ec1c9-0626-49cd-a320-d8618fd16f51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611b-f2c7-7291-beb5-3c0fe3445ba0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f611b-f2c7-7291-beb5-3c0fe3445ba0",
        "storage_key": "property/6767906449165592/019f611b-f2c7-7291-beb5-3c0fe3445ba0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_56ce05c6-7ef2-41bd-b5d2-5c1b7f5a7be0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611b-fd88-71fa-a9d6-4396ea34aefb.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019f611b-fd88-71fa-a9d6-4396ea34aefb",
        "storage_key": "property/6767906449165592/019f611b-fd88-71fa-a9d6-4396ea34aefb.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush palm trees and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4c1d395-376d-448f-b2a0-48027c36acc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611b-e296-768b-b8d9-f0254c93e56f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at an apartment complex.",
        "public_id": "019f611b-e296-768b-b8d9-f0254c93e56f",
        "storage_key": "property/6767906449165592/019f611b-e296-768b-b8d9-f0254c93e56f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush palm trees and comfortable lounge chairs. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f7ac7fe6-5f2e-4e3c-9b97-1b0f2262049d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Topgolf El Paso",
      "poi_type": "Restaurants",
      "poi_address": "365 Vin Rambla Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Golf-themed entertainment venue combining a driving range with dining and cocktails.",
      "poi_long_description": "People say this restaurant offers fun games, good food, and a variety of drink options. They highlight the lively atmosphere and the friendly, attentive staff. They also like the great party packages and the value, especially on Tuesdays when golfing is half price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2c94-7028-a7e8-16985c2048ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2c94-7028-a7e8-16985c2048ad",
        "storage_key": "property/6767906449165592/019cfb3b-2c94-7028-a7e8-16985c2048ad.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://topgolf.com/us/el-paso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10477886874640848166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-el-paso",
      "poi_latitude": "31.8107961",
      "poi_longitude": "-106.5250411",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-845-9028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxkkkflX54YRJhWyJ5nuaJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0b2b6d5a-0295-4da6-98d9-ea758d030201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "L & J Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3622 E Missouri Ave, El Paso, TX 79903, USA",
      "poi_short_description": "A local landmark dating back to 1927, this family-run eatery serves regional Mexican dishes & beers.",
      "poi_long_description": "People say this Mexican restaurant serves delicious green chile chicken enchiladas, steak tacos, and caldo de res. They highlight the affordable prices, generous portions, and fun, lively atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2c93-737d-8851-d7b5b562d385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2c93-737d-8851-d7b5b562d385",
        "storage_key": "property/6767906449165592/019cfb3b-2c93-737d-8851-d7b5b562d385.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://ljcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=253529114313290020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l--j-cafe",
      "poi_latitude": "31.7795154",
      "poi_longitude": "-106.4497953",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-566-8418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy58M-oRZ54YRJPHc3mK3hAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8910a82a-b8c7-4fb3-9edf-4a64c6e0ab23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Taco Santo",
      "poi_type": "Restaurants",
      "poi_address": "Panamá 955, Hidalgo, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2ddc-73ae-bc51-76171b965407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2ddc-73ae-bc51-76171b965407",
        "storage_key": "property/6767906449165592/019cfb3b-2ddc-73ae-bc51-76171b965407.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/TacoSantoJrz",
      "poi_directions_map_url": "https://maps.google.com/?cid=3674478626142168362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taco-santo",
      "poi_latitude": "31.7455368",
      "poi_longitude": "-106.4637579",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+52 656 351 6499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy8aTl1NZ54YRKiX4ndde_jI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9c80f7b3-251b-4a4d-ab05-59e7aad1f1e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Taconeta",
      "poi_type": "Restaurants",
      "poi_address": "311 Montana Ave A-1, El Paso, TX 79902, USA",
      "poi_short_description": "Laid-back eatery featuring tacos, margaritas and other Mexican fare.",
      "poi_long_description": "People say this taco restaurant serves delicious brisket, chicken, shrimp, and mushroom tacos, as well as elote, fried green beans, and sweet potatoes. They highlight the fresh ingredients, flavorful salsas, and unique take on Mexican food. They also like the friendly and efficient service, and the vibrant, fun atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2c98-779a-bb58-85eb7b965fe0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2c98-779a-bb58-85eb7b965fe0",
        "storage_key": "property/6767906449165592/019cfb3b-2c98-779a-bb58-85eb7b965fe0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.toasttab.com/taconeta",
      "poi_directions_map_url": "https://maps.google.com/?cid=10960950357964817459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taconeta",
      "poi_latitude": "31.7648439",
      "poi_longitude": "-106.4904197",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-303-8038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_NrqhpZ54YRMwQv50YeHZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_042284e3-914c-4b07-83b1-b261e2101d41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Salt + Honey Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1125 Texas Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Casual eatery for coffee & espresso drinks featuring all-day breakfast, brunch and burgers.",
      "poi_long_description": "People say this breakfast restaurant serves delicious chicken and waffles, baklava pancakes, and chilaquiles. They also highlight the attentive and friendly staff, and the vibrant and open dining space.\n\nOther reviews mention the wait time can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2c8a-77c8-90b1-ebed5f2466f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2c8a-77c8-90b1-ebed5f2466f4",
        "storage_key": "property/6767906449165592/019cfb3b-2c8a-77c8-90b1-ebed5f2466f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltandhoneyep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866789244147418890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt--honey-bakery-cafe",
      "poi_latitude": "31.7648676",
      "poi_longitude": "-106.4783652",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-313-4907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7y4m5dZ54YRCkcZPghPikM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_3b95b1a9-7ed7-48f9-9bb1-a3083985bb5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Pitt St, El Paso, TX 79912, USA",
      "poi_short_description": "Grocery chain including a bakery, an in-store bar and a salad bar.",
      "poi_long_description": "People say this grocery store offers a wide variety of organic foods, fresh produce, and baked goods, including a popular hot bar and pizza. They highlight the clean and modern atmosphere, and the convenient amenities such as a bread slicer and Amazon return area. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2ce3-735b-8463-d253de44ff07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2ce3-735b-8463-d253de44ff07",
        "storage_key": "property/6767906449165592/019cfb3b-2ce3-735b-8463-d253de44ff07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/elpaso?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5575333113701639611&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "31.8340462",
      "poi_longitude": "-106.5480013",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-236-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27f-7303-ba2c-dd548d6561b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27f-7303-ba2c-dd548d6561b4",
        "storage_key": "property/6767906449165592/019cfb3b-a27f-7303-ba2c-dd548d6561b4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj13blm_43YYRu6Wocu2PX00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ce17aa0f-0f54-45c2-97f8-da490906790d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "The Shoppes at Solana",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "One-time Sunland Park Mall now with a variety of national and local retailers, plus a food court and rock-climbing wall.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a good food court. They also highlight the clean restrooms and fun atmosphere, especially during events like fireworks displays.\n\nOther reviews mention the mall can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2db7-756b-8aa5-f281b2d6d393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2db7-756b-8aa5-f281b2d6d393",
        "storage_key": "property/6767906449165592/019cfb3b-2db7-756b-8aa5-f281b2d6d393.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "http://theshoppesatsolana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2107962478139008266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shoppes-at-solana",
      "poi_latitude": "31.8144216",
      "poi_longitude": "-106.5440443",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-833-5596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-816907bf67b2",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoWrRgA_43YYRCuVTlbT8QB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_61243ec5-6dd4-4b5d-b7d6-1bd6245dc9a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7545 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Retailer supplying tools, appliances, building materials, and home improvement items, plus installation services.",
      "poi_long_description": "People say this home improvement store is well-stocked and the staff is helpful and knowledgeable. They also highlight the friendly and attentive service, making it a pleasant shopping experience.\n\nSome reviews mention the wait times for assistance can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2db6-777c-8d6a-fb5f85308443.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2db6-777c-8d6a-fb5f85308443",
        "storage_key": "property/6767906449165592/019cfb3b-2db6-777c-8d6a-fb5f85308443.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/West-El-Paso/TX/El-Paso/79912/523?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7694583817001495963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.835826",
      "poi_longitude": "-106.5642035",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-585-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-816907bf67b2",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8zsx0lv43YYRm-3XwjanyGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_780bfa00-2eb1-47e5-90a4-57b0f6c16f6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "430 Redd Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Outdoor furniture store, lawn equipment rental service and building materials supplier providing items for home-repair projects.",
      "poi_long_description": "People say this home improvement store offers a wide variety of supplies for home projects. They also highlight the helpfulness of some staff members.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2c96-76b1-92b9-3a7f0573fca6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2c96-76b1-92b9-3a7f0573fca6",
        "storage_key": "property/6767906449165592/019cfb3b-2c96-76b1-92b9-3a7f0573fca6.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-El-Paso/1152?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1152-_-na-_-0-_-0&y_source=1_MTE4NDM4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5332424068888550467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.861958",
      "poi_longitude": "-106.5726474",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-581-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-816907bf67b2",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUewuiOb43YYRQ1zYMXCTAEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d4267c35-5455-4791-907d-e85e2f94443c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Fort Bliss - Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "1611 Haan Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Shopping mall at Freedom Crossing at Fort Bliss with a food court and tax-free bonus savings for military members and veterans.",
      "poi_long_description": "People say this shopping center offers a huge selection of products and services, including a food court with fantastic choices like New York-style pizza. They highlight the clean and well-organized layout, and the friendly and helpful staff. They also like the quick and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-2d96-7788-b342-ae046019ece4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2d96-7788-b342-ae046019ece4",
        "storage_key": "property/6767906449165592/019cfb3b-2d96-7788-b342-ae046019ece4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.shopmyexchange.com/exchange-stores/United%20States/TX/Ft.%20Bliss/Ft-Bliss--1011801",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221724360285077533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss---exchange",
      "poi_latitude": "31.8180883",
      "poi_longitude": "-106.4295632",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 915-562-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-816907bf67b2",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ83LPBZ9Z54YRHcC_Dibc2o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ccbc21aa-40e5-4526-9742-4d3b7cca8dcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "500 W University Ave, El Paso, TX 79968, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-30b9-73cf-965e-e00d57198ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-30b9-73cf-965e-e00d57198ce6",
        "storage_key": "property/6767906449165592/019cfb3b-30b9-73cf-965e-e00d57198ce6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.utep.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15130569928881990844&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-texas-at-el-paso",
      "poi_latitude": "31.7731979",
      "poi_longitude": "-106.5047208",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-747-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ12KA7lpY54YRvOw3ZC-V-tE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_96a079ec-418c-482d-ba40-68d353f91eb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Institute of Social Sciences and Administration",
      "poi_type": "Education",
      "poi_address": "Av. Universidad, Av. Heroico Colegio Militar y, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-30de-741f-96e3-a7b29150db35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-30de-741f-96e3-a7b29150db35",
        "storage_key": "property/6767906449165592/019cfb3b-30de-741f-96e3-a7b29150db35.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.uacj.mx/ICSA/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1922637532778773215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "institute-of-social-sciences-and-administration",
      "poi_latitude": "31.7568996",
      "poi_longitude": "-106.4483951",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+52 656 688 3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP2FS7WRZ54YR37ocRaaUrho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_452e2d1b-f221-4f18-aca3-a7f3a6fe0638",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Texas Tech University Health Sciences Center El Paso",
      "poi_type": "Education",
      "poi_address": "5001 El Paso Dr, El Paso, TX 79905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-30ba-73bc-a5df-b8f72ff437ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-30ba-73bc-a5df-b8f72ff437ca",
        "storage_key": "property/6767906449165592/019cfb3b-30ba-73bc-a5df-b8f72ff437ca.webp",
        "width": 1280,
        "height": 631
      },
      "poi_business_url": "http://www.elpaso.ttuhsc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3406232647974928991&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-tech-university-health-sciences-center-el-paso",
      "poi_latitude": "31.7741906",
      "poi_longitude": "-106.4322838",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-215-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3_KUadNb54YRX0Li3IteRS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8b2b0a04-5821-49ff-b133-4f7dda782bef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "University Library",
      "poi_type": "Education",
      "poi_address": "1900 Wiggins Rd, El Paso, TX 79968, USA",
      "poi_short_description": "University library with free admission and study space, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3153-765e-b4e4-c240dc22ed15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3153-765e-b4e4-c240dc22ed15",
        "storage_key": "property/6767906449165592/019cfb3b-3153-765e-b4e4-c240dc22ed15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utep.edu/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=16419899299576992938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-library",
      "poi_latitude": "31.7673321",
      "poi_longitude": "-106.50472",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-747-5672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27f-7303-ba2c-e1f8897336c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27f-7303-ba2c-e1f8897336c1",
        "storage_key": "property/6767906449165592/019cfb3b-a27f-7303-ba2c-e1f8897336c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7gl1lhY54YRqtT4pmoz3-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_100ab411-4f28-4a26-84e1-6fde0ab24f76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Southwest University",
      "poi_type": "Education",
      "poi_address": "6101 Montana Ave, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3180-7579-b2a6-212e99eded0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3180-7579-b2a6-212e99eded0f",
        "storage_key": "property/6767906449165592/019cfb3b-3180-7579-b2a6-212e99eded0f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://southwestuniversity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14473700373045968209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwest-university",
      "poi_latitude": "31.7881511",
      "poi_longitude": "-106.413014",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-778-4001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5KGL0Za54YRUf3X6M3p3Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d67bf972-6ac5-408d-84d6-970e70c8739b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Sun Bowl",
      "poi_type": "Entertainment",
      "poi_address": "2701 Sun Bowl Dr, El Paso, TX 79902, USA",
      "poi_short_description": "Stadium hosting concerts, football games, and Monster Jam events, plus tailgating.",
      "poi_long_description": "People say this stadium hosts a variety of events, including concerts, football games, and Monster Jam. They highlight the beautiful views of the surrounding mountains and the well-maintained facilities, including restrooms and concessions. They also like the spacious seating and the smooth traffic flow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-323d-72bc-bf6e-0bb36eea6e0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-323d-72bc-bf6e-0bb36eea6e0a",
        "storage_key": "property/6767906449165592/019cfb3b-323d-72bc-bf6e-0bb36eea6e0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12740333998005602376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sun-bowl",
      "poi_latitude": "31.7733442",
      "poi_longitude": "-106.5079256",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a269-7656-a452-a644994583ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a269-7656-a452-a644994583ed",
        "storage_key": "property/6767906449165592/019cfb3b-a269-7656-a452-a644994583ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ3x541xY54YRSMj0HkXCzrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_4323ae6b-55e4-4af5-b349-d0552e6aae1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Don Haskins Center",
      "poi_type": "Entertainment",
      "poi_address": "151 Glory Rd, El Paso, TX 79902, USA",
      "poi_short_description": "Arena hosting big concerts and other events with food, drink, and free parking.",
      "poi_long_description": "People say this arena is a great place to attend graduations and concerts, and they appreciate the well-organized events and comfortable temperature inside. They also highlight the ample parking and easy access to the venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3226-7226-b8ff-158e990b198a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3226-7226-b8ff-158e990b198a",
        "storage_key": "property/6767906449165592/019cfb3b-3226-7226-b8ff-158e990b198a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/venues/don_haskins_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11992951360778632993&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-haskins-center",
      "poi_latitude": "31.7776195",
      "poi_longitude": "-106.5056719",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-747-5481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46MilERY54YRIX-_o7iFb6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d1c2d9be-5e6a-44ed-8b66-953f00680113",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "Train Station, 4001 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Longstanding facility showcasing 250+ species within habitats, plus playground and cafe.",
      "poi_long_description": "People say this zoo offers a variety of animals, including penguins, sea lions, and giraffes, and has a fun splash pad and playground. They also highlight the affordable price, convenient size for families with young children, and friendly, knowledgeable staff.\n\nOther reviews mention some exhibits can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3270-7026-9801-d23a02bda0db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3270-7026-9801-d23a02bda0db",
        "storage_key": "property/6767906449165592/019cfb3b-3270-7026-9801-d23a02bda0db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154948632860338008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-zoo-and-botanical-gardens",
      "poi_latitude": "31.7690489",
      "poi_longitude": "-106.4448897",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-212-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7ASQX5Z54YRWKeWzkbpDH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_0a66336a-1367-4f4c-b941-0a8440b14bdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Estadio Olímpico Benito Juárez",
      "poi_type": "Entertainment",
      "poi_address": "Av. Heroico Colegio Militar 51, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this stadium offers a variety of events, including concerts and sporting activities, and has ample parking. They highlight the clean restrooms, good security, and acceptable sound quality. They also like the well-maintained track and stands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-326b-744c-9a5e-916255a81c32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-326b-744c-9a5e-916255a81c32",
        "storage_key": "property/6767906449165592/019cfb3b-326b-744c-9a5e-916255a81c32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2843042972014026862&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "estadio-olmpico-benito-jurez",
      "poi_latitude": "31.7526757",
      "poi_longitude": "-106.4682618",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+52 656 612 7417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a269-7656-a452-a644994583ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a269-7656-a452-a644994583ed",
        "storage_key": "property/6767906449165592/019cfb3b-a269-7656-a452-a644994583ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUR_bhxNZ54YRbiARHIWEdCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_dd0d2e8f-d4af-40e7-a3a9-f282f21cd3cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "La Nube STEAM Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "201 W Main Dr, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of interactive exhibits, including a water play area, a climbing structure, and a toddler area, as well as costumes and STEAM activities. They highlight the family-friendly vibe, the educational and entertaining experience, and the clean facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-326b-744c-9a5e-953a8ee639d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-326b-744c-9a5e-953a8ee639d6",
        "storage_key": "property/6767906449165592/019cfb3b-326b-744c-9a5e-953a8ee639d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.la-nube.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5422886930183727470&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-nube-steam-discovery-center",
      "poi_latitude": "31.7590797",
      "poi_longitude": "-106.4906986",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-290-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a262-77de-892c-c03f534b7618.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a262-77de-892c-c03f534b7618",
        "storage_key": "property/6767906449165592/019cfb3b-a262-77de-892c-c03f534b7618.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJTzDNKgBZ54YRbqm1au72QUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_52d5545f-faaa-41e2-8301-77f202d2dfbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Crunch Fitness - El Paso Dyer",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 Dyer St, El Paso, TX 79924, USA",
      "poi_short_description": "Clean, bright, spacious chain gym, featuring treadmills, elliptical trainers, bike trainers and weight machines, plus classes and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and a sauna, and the staff is friendly and welcoming.\n\nOther reviews mention the gym can be crowded and the membership pricing can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-34ba-7196-821c-205d67f6126e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-34ba-7196-821c-205d67f6126e",
        "storage_key": "property/6767906449165592/019cfb3b-34ba-7196-821c-205d67f6126e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/el-paso-dyer",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674348033972161344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---el-paso-dyer",
      "poi_latitude": "31.8722149",
      "poi_longitude": "-106.4278235",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 915-455-0044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7aPFYLpR54YRQMtIc6p6PBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2e8222ca-678d-4045-9100-ad5b1ba1b62d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Kinective Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "Modern gym with state-of-the-art machines, spa amenities and fitness classes, plus personal training.",
      "poi_long_description": "People say this fitness center offers a wide variety of classes, including yoga, Pilates, cycling, and Zumba, as well as state-of-the-art equipment and amenities like a sauna, steam room, and massage chairs. They highlight the positive energy, clean facilities, and convenient features such as a rooftop track, a bar, and a mini restaurant with smoothies, bowls, and salads. They also like the friendly and helpful staff, and the sense of community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-354b-71b2-a9d0-b3d99d24e23c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-354b-71b2-a9d0-b3d99d24e23c",
        "storage_key": "property/6767906449165592/019cfb3b-354b-71b2-a9d0-b3d99d24e23c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://kinective.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=844899700064661306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kinective-fitness-club",
      "poi_latitude": "31.8521899",
      "poi_longitude": "-106.5401454",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-260-9895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSrKKj753YYROi8w_cyvuQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_1bd5bf16-d5a3-4d67-a236-6b0838082761",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5700 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Chain gym with a variety of equipment, tanning, and massage services, plus 24-hour access.",
      "poi_long_description": "People say this gym offers a wide variety of high-quality equipment, including dumbbells and weight machines, and has a spa. They also highlight the clean facilities, spacious showers, and friendly, helpful staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-355c-71d6-898e-043b880a3d02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-355c-71d6-898e-043b880a3d02",
        "storage_key": "property/6767906449165592/019cfb3b-355c-71d6-898e-043b880a3d02.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-mesa-hills-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859376139751605018&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.8241974",
      "poi_longitude": "-106.5208557",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-585-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bh0xehX54YRGkOvrkFmMV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9a9e7c07-97f5-457a-900a-f51db12b8fae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "813 Sunland Park Dr Ste B, El Paso, TX 79912, USA",
      "poi_short_description": "Retailer for skin, hair, makeup, and fragrance products, including exclusives, plus in-store salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3552-77bb-880d-69aa30ba52c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3552-77bb-880d-69aa30ba52c0",
        "storage_key": "property/6767906449165592/019cfb3b-3552-77bb-880d-69aa30ba52c0.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/el-paso-tx-303",
      "poi_directions_map_url": "https://maps.google.com/?cid=9506694949814193497&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "31.8184478",
      "poi_longitude": "-106.5496002",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-581-0314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL73eNhD43YYRWc2sL7CQ7oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9ba93b6e-e98b-4d19-8f23-8f1bbf74ed88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Premium health club offering classes and training sessions in a welcoming atmosphere featuring fitness equipment and a turf area.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and cardio equipment, as well as group classes like Zumba and yoga. They highlight the friendly and helpful staff, and the welcoming and supportive atmosphere. They also like the clean facilities and the availability of amenities such as showers, saunas, and a daycare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-35bb-74cd-95bd-6a5d3e90c621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-35bb-74cd-95bd-6a5d3e90c621",
        "storage_key": "property/6767906449165592/019cfb3b-35bb-74cd-95bd-6a5d3e90c621.webp",
        "width": 1026,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/gym-near-me/tru-fit-texas/el-paso/sunland-mall/&utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15276080860203553813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs",
      "poi_latitude": "31.8145396",
      "poi_longitude": "-106.5462017",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-300-1993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1_VFxT53YYRFZSTMJuK_9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_05814a21-809e-4d9e-a8f2-f95394e9a745",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6910 N Mesa St Ste H Suite D, El Paso, TX 79912, USA",
      "poi_short_description": "Gymnastics center with USA Gymnastics-certified coaches offering classes for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-366c-74bb-ba7e-2e44309804a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-366c-74bb-ba7e-2e44309804a2",
        "storage_key": "property/6767906449165592/019cfb3b-366c-74bb-ba7e-2e44309804a2.webp",
        "width": 1008,
        "height": 567
      },
      "poi_business_url": "https://elpasogymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1102495125243281967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-gymnastics",
      "poi_latitude": "31.8356392",
      "poi_longitude": "-106.5482103",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-581-3476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg6HzWWX43YYRL8K5onnZTA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ff0328ef-bd4f-4a7c-b4ff-1fe59d30c477",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "981 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Gym chain with free weights and cardio machines, plus group fitness classes and saunas.",
      "poi_long_description": "People say this fitness center offers a decent amount of equipment and has friendly staff.\n\nOther reviews mention the bathrooms can be outdated and the equipment can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-36e4-75ed-a292-d9d50ea77245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-36e4-75ed-a292-d9d50ea77245",
        "storage_key": "property/6767906449165592/019cfb3b-36e4-75ed-a292-d9d50ea77245.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-resler/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7817928767867659509&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.86318139999999",
      "poi_longitude": "-106.5590516",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-760-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99A4Bwz53YYR9SQPEMvcfmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_b1975357-3d5c-4386-8407-a766be17ada5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso Animal Urgent Care West",
      "poi_type": "Health and Wellness",
      "poi_address": "5500 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-36d1-76ba-81ac-14d69f49ca60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-36d1-76ba-81ac-14d69f49ca60",
        "storage_key": "property/6767906449165592/019cfb3b-36d1-76ba-81ac-14d69f49ca60.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://elpasoanimalurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8021225143916288949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-animal-urgent-care-west",
      "poi_latitude": "31.8592417",
      "poi_longitude": "-106.575303",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-301-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-crCu353YYRtduPJsUdUW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_788aceac-6cb6-46cd-9162-57416e103355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Las Palmas Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 N Oregon St, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-36e6-74dc-8594-51ce85cd8cb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-36e6-74dc-8594-51ce85cd8cb6",
        "storage_key": "property/6767906449165592/019cfb3b-36e6-74dc-8594-51ce85cd8cb6.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://laspalmasdelsolhealthcare.com/locations/las-palmas-medical-center/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7797277200056017172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-palmas-medical-center",
      "poi_latitude": "31.7699653",
      "poi_longitude": "-106.4987868",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-521-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27d-7738-a263-2d88efeb55f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27d-7738-a263-2d88efeb55f6",
        "storage_key": "property/6767906449165592/019cfb3b-a27d-7738-a263-2d88efeb55f6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3k-QVdY54YRFGGXPE1-NWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3f13c53d-a034-49d1-b918-ff2bcc865865",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso Children’s Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4845 Alameda Ave, El Paso, TX 79905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-37f8-7513-a04b-c5f7a660e174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-37f8-7513-a04b-c5f7a660e174",
        "storage_key": "property/6767906449165592/019cfb3b-37f8-7513-a04b-c5f7a660e174.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://elpasochildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17164696348058008125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-childrens-hospital",
      "poi_latitude": "31.7716769",
      "poi_longitude": "-106.433967",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-298-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27d-7738-a263-2d88efeb55f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27d-7738-a263-2d88efeb55f6",
        "storage_key": "property/6767906449165592/019cfb3b-a27d-7738-a263-2d88efeb55f6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zuGd9Nb54YRPTpx12JANe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5379b172-232e-4822-ac8c-aebe6ba6eb1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Park featuring hills and shaded areas, an ice-cream truck, a playground and tennis courts for activities like walking and picnics.",
      "poi_long_description": "People say this city park offers plenty of grass for picnics and games, a playground, and shade from numerous trees. They highlight the peaceful and relaxing vibe, and the well-maintained grounds. They also like the nearby ice cream truck and library branch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3c97-77f6-a0af-841dd8f3b5c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3c97-77f6-a0af-841dd8f3b5c9",
        "storage_key": "property/6767906449165592/019cfb3b-3c97-77f6-a0af-841dd8f3b5c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a296-7725-82ab-62d0e6d73fe8",
        "storage_key": "property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e2adac91-5db5-40a4-ac21-a4a955999e17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Parque Público Federal El Chamizal",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Ing. David Herrera, C. Malecón, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "Ceded by the US to Mexico in 1963, this green space is now a public park for sports & recreation.",
      "poi_long_description": "People say this park offers green areas, a museum, and opportunities for picnics, running, and outdoor sports. They highlight the tranquil and relaxing vibe, and the spacious areas suitable for family gatherings and activities. They also like the well-maintained grounds and the opportunity to interact with squirrels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3c4e-7188-a20e-6e646b356c3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3c4e-7188-a20e-6e646b356c3f",
        "storage_key": "property/6767906449165592/019cfb3b-3c4e-7188-a20e-6e646b356c3f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16119446820157355735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parque-pblico-federal-el-chamizal",
      "poi_latitude": "31.7554974",
      "poi_longitude": "-106.4596892",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a296-7725-82ab-62d0e6d73fe8",
        "storage_key": "property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9BqGmxZ54YR13ZHe3rHs98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_82ad55e9-fcbc-432f-beec-987a7cefbdd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "DIF Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Av. Heroico Colegio Militar s/n, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3ae3-766d-aebf-0e4d4acad88d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3ae3-766d-aebf-0e4d4acad88d",
        "storage_key": "property/6767906449165592/019cfb3b-3ae3-766d-aebf-0e4d4acad88d.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5530219233310207241&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dif-park",
      "poi_latitude": "31.7514945",
      "poi_longitude": "-106.4652985",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a296-7725-82ab-62d0e6d73fe8",
        "storage_key": "property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVfTwxRZ54YRCe18oxdJv0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b9d6afad-d4f2-44d5-bad3-050886a009b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso Municipal Rose Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3418 Aurora Ave, El Paso, TX 79930, USA",
      "poi_short_description": "Peaceful oasis featuring different varieties of roses and other flowers, with benches and a fountain.",
      "poi_long_description": "People say this garden offers a wide variety of beautiful roses and other flowers. They highlight the peaceful and serene atmosphere, perfect for walking, sitting, and meditation. They also like the well-maintained pathways and shaded seating areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3ecf-7066-b489-0f265efba5e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3ecf-7066-b489-0f265efba5e2",
        "storage_key": "property/6767906449165592/019cfb3b-3ecf-7066-b489-0f265efba5e2.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16475470708097522831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-municipal-rose-garden",
      "poi_latitude": "31.7928257",
      "poi_longitude": "-106.4530369",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a296-7725-82ab-62d0e6d73fe8",
        "storage_key": "property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT37fuJJZ54YRj5yBd1GhpOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_45dfd85d-bf05-43b9-840a-d2269f9be5ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Chamizal National Memorial",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 S San Marcial St, El Paso, TX 79905, USA",
      "poi_short_description": "Spacious memorial park for the 1963 settlement of a border dispute between the U.S. and Mexico.",
      "poi_long_description": "Visitors say this memorial park offers peaceful walking trails, scenic views, and picnic areas, and they highlight its historical significance. They also like that it's clean, quiet, and relaxing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3f5d-771a-9702-65b375f0503d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3f5d-771a-9702-65b375f0503d",
        "storage_key": "property/6767906449165592/019cfb3b-3f5d-771a-9702-65b375f0503d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nps.gov/cham/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=3141076655758003265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chamizal-national-memorial",
      "poi_latitude": "31.7672409",
      "poi_longitude": "-106.4543374",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-532-7273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a296-7725-82ab-62d0e6d73fe8",
        "storage_key": "property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwoGGHdZ54YRQUy6hpNYlys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d91823b0-1246-4752-b174-c55ef49919bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Fort Bliss A/DACG",
      "poi_type": "Transportation & Transit",
      "poi_address": "Fort Bliss, TX 79918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3e65-72ab-9183-adbbb54bfc35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3e65-72ab-9183-adbbb54bfc35",
        "storage_key": "property/6767906449165592/019cfb3b-3e65-72ab-9183-adbbb54bfc35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://home.army.mil/hood/index.php/units-tenants/installation-transportation-office/arrivaldeparture-airfield-control-group-dacg",
      "poi_directions_map_url": "https://maps.google.com/?cid=10912390521258870755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss-adacg",
      "poi_latitude": "31.8294155",
      "poi_longitude": "-106.4096364",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-568-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a558-75f8-939d-0906b2f9f797.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a558-75f8-939d-0906b2f9f797",
        "storage_key": "property/6767906449165592/019cfb3b-a558-75f8-939d-0906b2f9f797.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx8btptQ54YR44f53VyZcJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_68bab974-224d-483e-ad0b-9015df789d00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W San Francisco Ave, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3eff-771b-9d6f-0d1c27404fcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3eff-771b-9d6f-0d1c27404fcc",
        "storage_key": "property/6767906449165592/019cfb3b-3eff-771b-9d6f-0d1c27404fcc.webp",
        "width": 1280,
        "height": 818
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ELP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091980658630256344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso",
      "poi_latitude": "31.7573824",
      "poi_longitude": "-106.4959039",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a558-75f8-939d-07c1649958a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a558-75f8-939d-07c1649958a4",
        "storage_key": "property/6767906449165592/019cfb3b-a558-75f8-939d-07c1649958a4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8VMdftY54YR2OaAEdrpMu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_495ebf29-8429-4bf6-b591-f386aa055ed3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "ACS Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2494 Ricker Rd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3eba-70c8-80cd-de07b213c1ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3eba-70c8-80cd-de07b213c1ad",
        "storage_key": "property/6767906449165592/019cfb3b-3eba-70c8-80cd-de07b213c1ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/army-community-service",
      "poi_directions_map_url": "https://maps.google.com/?cid=15641003975660933022&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "acs-building",
      "poi_latitude": "31.808537",
      "poi_longitude": "-106.4167551",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 915-569-4227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2nL5o5b54YRng--Cz8CENk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_526913ff-f41a-4385-9fae-056133d9cc72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Campbell St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3efc-77ce-b878-4d188a2063df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3efc-77ce-b878-4d188a2063df",
        "storage_key": "property/6767906449165592/019cfb3b-3efc-77ce-b878-4d188a2063df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7004826674061616697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-city-hall",
      "poi_latitude": "31.7618251",
      "poi_longitude": "-106.4853072",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-212-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27f-7303-ba2c-e1f8897336c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27f-7303-ba2c-e1f8897336c1",
        "storage_key": "property/6767906449165592/019cfb3b-a27f-7303-ba2c-e1f8897336c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8RKcPxY54YROaafNL8kNmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_e472a8d9-8e03-485b-98e4-d8ed2cb9d63e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "WestStar Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 N Mesa St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-3f0b-7261-a37a-a7d3825d5441.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-3f0b-7261-a37a-a7d3825d5441",
        "storage_key": "property/6767906449165592/019cfb3b-3f0b-7261-a37a-a7d3825d5441.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.weststartower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17936696281012297070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "weststar-tower",
      "poi_latitude": "31.7619103",
      "poi_longitude": "-106.4902384",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-532-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0X5dzG9Z54YRbt3OITzy6_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f721edd4-7675-4252-92d7-a3c551222a75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "1 Civic Center Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Civic Center Plaza, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-411f-745b-81bd-71736dfc08de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-411f-745b-81bd-71736dfc08de",
        "storage_key": "property/6767906449165592/019cfb3b-411f-745b-81bd-71736dfc08de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12352449684385399443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "1-civic-center-plaza",
      "poi_latitude": "31.7576845",
      "poi_longitude": "-106.4917571",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVV8fxY54YRk4Ktt4q3bKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_88240328-3b7f-41a8-b35d-ed2f68676bc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "5th Armored Brigade",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1002 Pleasonton Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-4220-734c-b77d-e6395628a147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-4220-734c-b77d-e6395628a147",
        "storage_key": "property/6767906449165592/019cfb3b-4220-734c-b77d-e6395628a147.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14958475088164677305&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "5th-armored-brigade",
      "poi_latitude": "31.808054",
      "poi_longitude": "-106.426845",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8cTJxBa54YRueaV29Ytl88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e857aedf-5906-4915-819b-d45c5ecdb14c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Dr. Green Elementary School",
      "poi_type": "Education",
      "poi_address": "5430 Buckley Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-ca16-76c9-95d5-71b4b980f044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ca16-76c9-95d5-71b4b980f044",
        "storage_key": "property/6767906449165592/019d7911-ca16-76c9-95d5-71b4b980f044.webp",
        "width": 1280,
        "height": 507
      },
      "poi_business_url": "https://www.episd.org/o/gres",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283601174716929722&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dr-green-elementary-school",
      "poi_latitude": "31.822663",
      "poi_longitude": "-106.511893",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-236-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF_WoxuxX54YRutaGKrKv2-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ebaac07e-5acd-4603-a3fb-a5c00cc7d50c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Carlos Rivera Elementary School",
      "poi_type": "Education",
      "poi_address": "6445 Escondido Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://rivera.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4456028750516349836&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carlos-rivera-elementary-school",
      "poi_latitude": "31.8431675",
      "poi_longitude": "-106.534159",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-236-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFWBG-NVX54YRjGt0H4r-1j0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_786230a6-0080-4a51-b2bc-df47618c35af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Guerrero Elementary School",
      "poi_type": "Education",
      "poi_address": "7530 Lakehurst Rd, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-cb33-7335-b57f-850d7acb289c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cb33-7335-b57f-850d7acb289c",
        "storage_key": "property/6767906449165592/019d7911-cb33-7335-b57f-850d7acb289c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://guerrero.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7191872854877687689&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "guerrero-elementary-school",
      "poi_latitude": "31.8553898",
      "poi_longitude": "-106.5645083",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-236-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY9LEJ_L43YYRiU_C4EGqzmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_faba099a-bc9b-43a0-acde-4014e22bfac9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Polk Elementary School",
      "poi_type": "Education",
      "poi_address": "940 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-cb6f-767a-ab28-09baa35908a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cb6f-767a-ab28-09baa35908a7",
        "storage_key": "property/6767906449165592/019d7911-cb6f-767a-ab28-09baa35908a7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.episd.org/polk",
      "poi_directions_map_url": "https://maps.google.com/?cid=5966228576004355288&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "polk-elementary-school",
      "poi_latitude": "31.8518194",
      "poi_longitude": "-106.5427415",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-236-2775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ31RZ74b43YYR2DSGiUdNzFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_14054f26-e098-44a3-ad7b-73e3a809a5a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Lundy Elementary School",
      "poi_type": "Education",
      "poi_address": "6201 High Ridge Dr Basecamp 1, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://lundy.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12430004791866115903&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lundy-elementary-school",
      "poi_latitude": "31.8701689",
      "poi_longitude": "-106.5248711",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-230-5075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIQFxrCJW54YRP0eVT4A_gKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c3b428bd-026b-4df2-9d18-73f8a327bc96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Hornedo Middle School",
      "poi_type": "Education",
      "poi_address": "6101 High Ridge Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-c9fd-778c-8038-efa4cec07fcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c9fd-778c-8038-efa4cec07fcd",
        "storage_key": "property/6767906449165592/019d7911-c9fd-778c-8038-efa4cec07fcd.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.episd.org/hornedo",
      "poi_directions_map_url": "https://maps.google.com/?cid=7710372300509239893&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hornedo-middle-school",
      "poi_latitude": "31.8707115",
      "poi_longitude": "-106.5226258",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-236-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIyZZd5T43YYRVVrdicG-AGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1232f414-b72d-4afc-899f-087637745be7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Brown Middle School",
      "poi_type": "Education",
      "poi_address": "7820 Helen of Troy Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-d323-712b-865f-4addf7241304.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d323-712b-865f-4addf7241304",
        "storage_key": "property/6767906449165592/019d7911-d323-712b-865f-4addf7241304.webp",
        "width": 720,
        "height": 861
      },
      "poi_business_url": "http://brown.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13624316976225371440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brown-middle-school",
      "poi_latitude": "31.8778583",
      "poi_longitude": "-106.5726936",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-236-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgcu4z9n43YYRMMU86xpME70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_0d48582d-3cab-4d7e-b184-398e197380dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Coronado High School",
      "poi_type": "Education",
      "poi_address": "100 Champions Pl, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-d93c-755e-9f48-590d90bcf4ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d93c-755e-9f48-590d90bcf4ef",
        "storage_key": "property/6767906449165592/019d7911-d93c-755e-9f48-590d90bcf4ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://coronado.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14130504508255682606&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coronado-high-school",
      "poi_latitude": "31.8370723",
      "poi_longitude": "-106.5467083",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-236-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCSIuemX43YYRLsCiz_uiGcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_48cc0f90-dc64-4969-9961-4909bf2f6756",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Canutillo High School",
      "poi_type": "Education",
      "poi_address": "6675 S Desert Blvd, El Paso, TX 79932, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-d84d-771d-bd75-b9bd62946167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d84d-771d-bd75-b9bd62946167",
        "storage_key": "property/6767906449165592/019d7911-d84d-771d-bd75-b9bd62946167.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://chs.canutillo-isd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11911219635572230511&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "canutillo-high-school",
      "poi_latitude": "31.8969741",
      "poi_longitude": "-106.5851383",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-877-7801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbYI3oov-3YYRb8nwcyYnTaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_340f167b-32ab-451d-ab5c-21944dc1fb6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "The University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "3333 N Mesa St, El Paso, TX 79902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.utep.edu/chs/pt/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15385263784180211019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-texas-at-el-paso",
      "poi_latitude": "31.7831287",
      "poi_longitude": "-106.5067634",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-747-8207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-7cac50bd4718",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-7cac50bd4718.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzfwroGBZ54YRS12-p-Vvg9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_15832f65-c03f-4aec-acfd-28b7186d1d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "West Towne Marketplace",
      "poi_type": "Restaurants",
      "poi_address": "6450 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-e305-7229-9015-d08fb1c2eae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e305-7229-9015-d08fb1c2eae7",
        "storage_key": "property/6767906449165592/019d7911-e305-7229-9015-d08fb1c2eae7.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.westtownemarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6200452196652621941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "west-towne-marketplace",
      "poi_latitude": "31.8859871",
      "poi_longitude": "-106.5800291",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMXdSgNb43YYRdSBF5GtuDFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_22461067-04db-4979-aeb7-be960c1407e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Sunland Towne Centre",
      "poi_type": "Restaurants",
      "poi_address": "655 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Shopping mall with stores and eateries, including IHOP.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-e27b-714b-a558-e1c6695261bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e27b-714b-a558-e1c6695261bb",
        "storage_key": "property/6767906449165592/019d7911-e27b-714b-a558-e1c6695261bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiterealty.com/properties/sunland-towne-centre",
      "poi_directions_map_url": "https://maps.google.com/?cid=583659051639867361&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunland-towne-centre",
      "poi_latitude": "31.8210631",
      "poi_longitude": "-106.5426851",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-816907bf67b2",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJW0M-HQz43YYR4YfvqtCSGQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8962daa5-b2f4-4ee4-af89-0401085b9b72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Literarity Book Shop",
      "poi_type": "Restaurants",
      "poi_address": "5411 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Cozy bookstore featuring new and used copies alongside signed editions, rarities and collectibles.",
      "poi_long_description": "People say this bookstore offers a wide variety of genres, including rare books, collector editions, and works by local and indie authors. They highlight the reasonable prices and the comfortable, quaint vibe. They also like the knowledgeable and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-e72c-763a-aaad-c1e0fc9079c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e72c-763a-aaad-c1e0fc9079c3",
        "storage_key": "property/6767906449165592/019d7911-e72c-763a-aaad-c1e0fc9079c3.webp",
        "width": 1280,
        "height": 979
      },
      "poi_business_url": "https://bookshop.org/shop/Literarity",
      "poi_directions_map_url": "https://maps.google.com/?cid=18436675264398338670&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "literarity-book-shop",
      "poi_latitude": "31.8184806",
      "poi_longitude": "-106.5175602",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-307-4760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a270-703f-90de-816907bf67b2",
        "storage_key": "property/6767906449165592/019cfb3b-a270-703f-90de-816907bf67b2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrbLmAe5X54YRbqqxpXg63P8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_66eb8c5a-d592-40f0-bbb2-f6682f419e28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "5401 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "People say this coffee shop offers tasty donuts, especially the Boston Kreme. They also highlight the fast, friendly, and prompt service, and the welcoming and professional staff.\n\nOther reviews mention the donuts can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-ee87-758d-bd19-f319267661e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ee87-758d-bd19-f319267661e4",
        "storage_key": "property/6767906449165592/019d7911-ee87-758d-bd19-f319267661e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/tx/el-paso/5401-n-mesa-st/355708?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=355708&y_source=1_MTIxMTI2NDYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6032380781638168406&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "31.8180471",
      "poi_longitude": "-106.5163214",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-304-0771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7912-1883-7369-aa29-9cf6765085e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1883-7369-aa29-9cf6765085e9",
        "storage_key": "property/6767906449165592/019d7912-1883-7369-aa29-9cf6765085e9.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJE345D_JX54YRVq9vJ1xSt1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_d8232347-5964-47f9-9efa-600ebd5ff179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Little Shack",
      "poi_type": "Restaurants",
      "poi_address": "5360 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "This easygoing joint with deck seating fixes up fish tacos, ceviche & other Mexican seafood eats.",
      "poi_long_description": "People say this seafood restaurant serves delicious fish and shrimp tacos, as well as other dishes like quesadillas and ceviche. They highlight the reasonable prices, fast service, and seaside shack vibe. They also like the attentive staff and the availability of specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-f107-7092-b55c-c06cb10942e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f107-7092-b55c-c06cb10942e0",
        "storage_key": "property/6767906449165592/019d7911-f107-7092-b55c-c06cb10942e0.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "http://thelittleshack.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9982961151891638449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "little-shack",
      "poi_latitude": "31.8172704",
      "poi_longitude": "-106.5142214",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-321-1562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcxp9PJX54YRsYgGkUaaioo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_9eb6109e-53f1-42a7-8474-cab06ab94431",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Mi Piaci Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "810 E Redd Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Upscale Italian option for homemade pastas, steaks & seafood in subdued surrounds with patio dining.",
      "poi_long_description": "People say this Italian restaurant serves delicious dishes, including carbonara, penne alla vodka, and pizza. They also highlight the impeccable and swift service, and the pleasant and relaxing atmosphere.\n\nOther reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-fac4-760d-be50-0a591d34593f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fac4-760d-be50-0a591d34593f",
        "storage_key": "property/6767906449165592/019d7911-fac4-760d-be50-0a591d34593f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mipiaciep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12346196493975047294&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mi-piaci-restaurant",
      "poi_latitude": "31.8604827",
      "poi_longitude": "-106.5517319",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-875-0034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySM5B-5X54YRfkyOXkyAVqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_d1151e61-cd0c-4b0e-ac8b-f205b6d94042",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Angry Owl Southwest Grill & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "4799 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Colorful Southwestern eatery offering mesquite-spiced grills, and potent cocktails.",
      "poi_long_description": "People say this restaurant serves delicious burgers, carnitas tacos, and nachos. They also highlight the great selection of drinks and beers, and the efficient service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-fabd-77de-855c-1fff591bc7d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fabd-77de-855c-1fff591bc7d8",
        "storage_key": "property/6767906449165592/019d7911-fabd-77de-855c-1fff591bc7d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://angryowlgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=552596498296411643&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "angry-owl-southwest-grill-cantina",
      "poi_latitude": "31.8066152",
      "poi_longitude": "-106.5097667",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-532-2450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTaeVQCBY54YR-xUVYZY3qwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_24ebde67-e600-44e5-8957-24ff45d25a75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Great American Steakburger",
      "poi_type": "Restaurants",
      "poi_address": "701 S Mesa Hills Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Casual operation serving signature steakburgers, BBQ & choice steaks, with a full bar.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, burgers, and seafood, including filet mignon, ribeye, and salmon. They highlight the generous portions, especially the steak sandwich, and the attentive service. They also like the comfortable and distinguished atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-fbae-7102-9d78-f11dec85c119.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fbae-7102-9d78-f11dec85c119",
        "storage_key": "property/6767906449165592/019d7911-fbae-7102-9d78-f11dec85c119.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://greatamericansteakburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1756343400186062800&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "great-american-steakburger",
      "poi_latitude": "31.8162916",
      "poi_longitude": "-106.5390382",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-585-7873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a27c-738c-b0b1-9a4ba4234966",
        "storage_key": "property/6767906449165592/019cfb3b-a27c-738c-b0b1-9a4ba4234966.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb87SkAj43YYR0CexVwTJXxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_034963a5-9eb0-4922-9368-9ef2273f6946",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Entertainment",
      "poi_address": "Thunderbird Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Hiking area offering shade trees, sunset views, and a grilling area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7911-ff1e-7781-96b7-a33f80650da0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ff1e-7781-96b7-a33f80650da0",
        "storage_key": "property/6767906449165592/019d7911-ff1e-7781-96b7-a33f80650da0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3261171865648773583&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.8513961",
      "poi_longitude": "-106.5098828",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0EHk0pW54YRzzl-i4gCQi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_5c3ea03f-fe29-4045-aee7-ade42e1588e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Westside Natatorium",
      "poi_type": "Entertainment",
      "poi_address": "650 Wallenberg Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Indoor swimming pool with a focus on cleanliness, organization, and friendly staff.",
      "poi_long_description": "People say this indoor swimming pool offers a huge pool and spacious restrooms and showers. They also highlight the friendly lifeguards and front desk staff, and the wholesome, kid-friendly environment with safety precautions.\n\nOther reviews mention the pool can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7912-0917-72b3-b123-a36d6ff03629.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0917-72b3-b123-a36d6ff03629",
        "storage_key": "property/6767906449165592/019d7912-0917-72b3-b123-a36d6ff03629.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks/aquatics/aquatic-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9448625875114838633&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "westside-natatorium",
      "poi_latitude": "31.8160255",
      "poi_longitude": "-106.5323124",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-212-0458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3L-zeJX54YRacrIJSxDIIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_b533c77b-6d05-4de3-ad48-c8fe630c0751",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Keystone Heritage Park and the El Paso Desert Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "4200 Doniphan Dr, El Paso, TX 79922, USA",
      "poi_short_description": "This 52-acre park features botanical gardens, wetlands & the remains of an ancient village.",
      "poi_long_description": "People say this botanical garden offers beautiful, tranquil, and well-maintained nature trails, a thriving pond filled with bird life, and a maze. They highlight the peaceful and relaxing atmosphere, and the opportunity to learn about the historic Rio Grande Del Norte and the local flora and fauna. They also like the affordable entry fee and the availability of shade and seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7912-0558-72f1-94b4-0c2f639dabed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0558-72f1-94b4-0c2f639dabed",
        "storage_key": "property/6767906449165592/019d7912-0558-72f1-94b4-0c2f639dabed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.keystoneheritagepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12019324138855344271&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "keystone-heritage-park-and-the-el-paso-desert-botanical-garden",
      "poi_latitude": "31.820571",
      "poi_longitude": "-106.563529",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-490-8571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzjy2D743YYRjyjAiJ83zaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_dfca3258-b95d-494b-abf2-c01034f7a057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "El Paso Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1 Arts Festival Plaza, El Paso, TX 79901, USA",
      "poi_short_description": "Works in 5 galleries reflect the area's American, Mexican & European roots.",
      "poi_long_description": "People say this museum offers a unique and diverse art experience, with some great historical pieces and student art. They highlight the free admission and the well-maintained, clean space. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7912-0896-71ae-a4d1-d637bbbb11b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0896-71ae-a4d1-d637bbbb11b2",
        "storage_key": "property/6767906449165592/019d7912-0896-71ae-a4d1-d637bbbb11b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epma.art/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17054373816264367256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-museum-of-art",
      "poi_latitude": "31.7585876",
      "poi_longitude": "-106.4902692",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-212-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a262-77de-892c-c03f534b7618.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a262-77de-892c-c03f534b7618",
        "storage_key": "property/6767906449165592/019cfb3b-a262-77de-892c-c03f534b7618.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxWj_B1Z54YRmBwpwaBOrew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_01bc8a62-8f0e-4c9d-9636-050406135263",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Wyler Aerial Tramway",
      "poi_type": "Entertainment",
      "poi_address": "1700 McKinley Ave, El Paso, TX 79930, USA",
      "poi_short_description": "Gondolas traveling to and from Ranger Peak plus a gift shop, restrooms & viewing platforms.",
      "poi_long_description": "Gondolas traveling to and from Ranger Peak plus a gift shop, restrooms & viewing platforms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7912-0eb5-768b-a2a8-512fbafba1ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0eb5-768b-a2a8-512fbafba1ae",
        "storage_key": "property/6767906449165592/019d7912-0eb5-768b-a2a8-512fbafba1ae.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/wyler-aerial-tramway",
      "poi_directions_map_url": "https://maps.google.com/?cid=10702077498266787339&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wyler-aerial-tramway",
      "poi_latitude": "31.8093698",
      "poi_longitude": "-106.4783946",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 915-566-6622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a296-7725-82ab-62d0e6d73fe8",
        "storage_key": "property/6767906449165592/019cfb3b-a296-7725-82ab-62d0e6d73fe8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVEfBtdZ54YRC57kWshqhZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ba895f54-2d1b-4ada-ae42-aa2315b6c75b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Sunland Park Racetrack & Casino",
      "poi_type": "Entertainment",
      "poi_address": "1200 Futurity Dr, Sunland Park, NM 88063, USA",
      "poi_short_description": "Entertainment complex featuring a track for horse racing, casino with slots & 2 restaurants.",
      "poi_long_description": "People say this casino offers a variety of gambling options, including slots, video poker, electronic table games, and horse racing. They also highlight the friendly and helpful staff, and the fun and exciting atmosphere.\n\nOther reviews mention the casino can be smoky.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019d7912-1216-77e8-9d72-b9abba7b660c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1216-77e8-9d72-b9abba7b660c",
        "storage_key": "property/6767906449165592/019d7912-1216-77e8-9d72-b9abba7b660c.webp",
        "width": 537,
        "height": 420
      },
      "poi_business_url": "http://www.sunland-park.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10680450856454078792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunland-park-racetrack-casino",
      "poi_latitude": "31.8048639",
      "poi_longitude": "-106.5598271",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 575-874-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-a26e-773c-af66-1c8189d9f254",
        "storage_key": "property/6767906449165592/019cfb3b-a26e-773c-af66-1c8189d9f254.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9ClnCH43YYRSEH2a3eVOJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_f4c536e2-3a86-448a-bf63-a9d53ce8501c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Thymes Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "thymes-restaurant",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c71b90b4-1fa6-49d9-b29f-e128ff460a3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "poi_name": "Alamo Drafthouse Monticello",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "alamo-drafthouse-monticello",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2b1dc5bd10359d3cf9e96ff6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9a27e198004fe6e8143e73de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2aec9f6877a51dd88f306456",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_52e377bb0cc3473346f3e03a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ab9aa06e1d256e63012bada5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_3c05ff3067c6b7bef0aa4b7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0ae726ae-899d-4d45-b82c-c0941bbb867f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "rating": "5.0",
      "name": "Elvira Ovando",
      "text": "Really great experience with the Chimney Apartments the office staff Victoria and Laura were amazing!! They helped with the move in process it was so seemless also Vero the cleaning lady left the apartment spotless for move in Jaime the maintenance gentleman was also really great! He installed a new shower head for me great location really nice apartment complex I was impressed with there amenities plus a really nice large pool. I definitely recommend these apartments located in the west side awesome experience!! Love my new home!",
      "date": "2025-09-23",
      "title": ""
    },
    {
      "id": "custom_e4a24cbd-01ec-4991-ab85-7b67c7dc3025",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "rating": "5.0",
      "name": "aleix carri",
      "text": "I have been living there for 2 years. In an apartment with one room. Those are wonderful apartments, in a great location in El Paso, connected to the main street of the west side. The pool and grill are good to and usually are in good conditions.\nThe last year I was there we had to many water shut offs… I do not know exactly why… and on my first year we have had some pool parties that they have messed up the pool and the grill.\nBut those are just two bad experience in 2 years of living there, that has been wonderful, neighbors are super nice, managment are always ready to help in anything so I would recomment living there ☺️",
      "date": "2025-08-30",
      "title": ""
    },
    {
      "id": "custom_8eaa38d9-8d1d-4ff9-bf05-d72f57e7a82d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "rating": "5.0",
      "name": "Carmen Antal",
      "text": "Mr. Jaime from maintenance did an excellent job replacing the wax seal for the toilet. He did it in a very profesional manner.",
      "date": "2025-08-24",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8979a4bb-cab0-479f-acb5-69151e5a05cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3c-6929-757b-ab2c-5af355719877.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment kitchen with bar seating.",
        "public_id": "019cfb3c-6929-757b-ab2c-5af355719877",
        "storage_key": "property/6767906449165592/019cfb3c-6929-757b-ab2c-5af355719877.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Chimneys Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6304bb633bd8dd2e49eb9576"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-216a-7538-ac2e-022c5663d0ea",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "chimneys-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592"
    },
    {
      "lead_collector_id": "019cf79e-21da-712e-9c34-5a57c8a2545d",
      "lead_source": "LANDING_PAGE",
      "name": "chimneys-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "generator",
      "page_item_url": "chimneys-apts-pool-el-paso-tx",
      "search_query": "apartments with pool El Paso TX",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in El Paso, TX",
      "h2_subtitle": "Discover the luxury of apartments with a pool in El Paso, TX. Dive into relaxation at Chimneys Apts. with top-notch amenities.",
      "page_copy": "Welcome to Chimneys Apts., where luxurious living meets the vibrant city of El Paso, TX. Our community offers exquisite one- and two-bedroom apartments with convenient amenities such as a state-of-the-art fitness center and a cozy clubhouse. One of our standout features is the sparkling pool, perfect for cooling off during those sunny Texas days. It’s not just a pool; it's a gathering spot where you can unwind and connect with neighbors. While you enjoy your time by the pool, your furry friends can have fun in the pet play area.\n\nLocated in the charming Festival Hills neighborhood, our attractive community is designed with your comfort in mind. Spacious walk-in closets and private balconies in each apartment enhance your living experience, providing you with a personal sanctuary. Whether you're lounging by the pool or enjoying a home-cooked meal in your modern kitchen, Chimneys Apts. offers a perfect blend of relaxation and recreation. Visit us and see why living with a pool is an experience unlike any other in El Paso, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
      "featured_image_media": {
        "alt_text": "The Chimney's Apartment Homes monument sign with phone number and landscaping.",
        "public_id": "019cfb3b-11b2-721d-8159-8503964fb8e9",
        "storage_key": "property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in El Paso, TX",
      "seo_description": "Discover Chimneys Apts. in El Paso, TX, featuring a sparkling pool and amenities. Enjoy luxury living with our spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "generator",
      "page_item_url": "chimneys-apts-dog-park-festival-hills",
      "search_query": "dog park apartments Festival Hills",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Festival Hills",
      "h2_subtitle": "Experience premium living in dog park apartments at Festival Hills. Chimneys Apts. welcomes pets with a dedicated pet play area.",
      "page_copy": "Nestled in the vibrant Festival Hills neighborhood, Chimneys Apts. offers a unique blend of comfort and convenience in El Paso, TX. Our one- and two-bedroom apartments come with an array of top-notch amenities designed to enhance your lifestyle. Pet owners will be delighted by our dedicated pet play area, making these the perfect dog park apartments in Festival Hills. Your furry friends will love the opportunity to run and play while you relax and connect with fellow pet enthusiasts.\n\nAt Chimneys Apts., our commitment to quality living extends beyond our pet-friendly features. Residents have access to a state-of-the-art fitness center, a sparkling pool, and a clubhouse. Conveniently located near local attractions and shopping in Festival Hills, our community is perfect for those seeking an urban lifestyle without sacrificing space or comfort. Discover the ideal pet-friendly living experience—your perfect home awaits at Chimneys Apts. in Festival Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
      "featured_image_media": {
        "alt_text": "The Chimney's Apartment Homes monument sign with phone number and landscaping.",
        "public_id": "019cfb3b-11b2-721d-8159-8503964fb8e9",
        "storage_key": "property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Festival Hills",
      "seo_description": "Find your home at Chimneys Apts. in Festival Hills, offering a pet play area and modern amenities for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "generator",
      "page_item_url": "chimneys-apts-air-conditioned-el-paso",
      "search_query": "air conditioned apartments El Paso",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in El Paso",
      "h2_subtitle": "Stay cool in El Paso's heat with air conditioned apartments. Chimneys Apts. offers modern comfort in a vibrant setting.",
      "page_copy": "Experience the ultimate comfort at Chimneys Apts., where air conditioned apartments provide a refreshing escape from the El Paso heat. Our one- and two-bedroom apartments are designed with your well-being in mind, featuring spacious walk-in closets and private balconies. Located in the lively Festival Hills neighborhood, Chimneys Apts. combines modern living with irresistible amenities.\n\nBeyond air conditioning, residents of Chimneys Apts. enjoy access to a sparkling pool, state-of-the-art fitness center, and a clubhouse, ensuring both relaxation and recreation are at your fingertips. Pet lovers will appreciate our dedicated pet play area, making Chimneys Apts. a welcoming community for all. Discover why Chimneys Apts. is a top choice for those seeking air conditioned comfort combined with luxury in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
      "featured_image_media": {
        "alt_text": "The Chimney's Apartment Homes monument sign with phone number and landscaping.",
        "public_id": "019cfb3b-11b2-721d-8159-8503964fb8e9",
        "storage_key": "property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in El Paso",
      "seo_description": "Discover cool living at Chimneys Apts. in El Paso, with air conditioned rooms, a pool, and luxury amenities. Perfect for comfort seekers in Texas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "generator",
      "page_item_url": "chimneys-apts-with-dishwasher-79912",
      "search_query": "apartments with dishwasher 79912",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in 79912",
      "h2_subtitle": "Explore modern conveniences in apartments with dishwashers in the 79912 area. Choose Chimneys Apts. for a hassle-free lifestyle.",
      "page_copy": "Welcome to Chimneys Apts., where convenience and style meet in the bustling 79912 zip code of El Paso, TX. Our one- and two-bedroom apartments are thoughtfully equipped with dishwashers, making kitchen clean-up a breeze. Enjoy the modern amenities designed to simplify your day-to-day life while enhancing your overall living experience.\n\nSituated in the charming Festival Hills neighborhood, Chimneys Apts. provides residents with more than just in-unit conveniences. Delight in shared community features, including a sparkling pool, a fitness center, and a welcoming clubhouse. Whether you're a pet owner or a fitness enthusiast, you'll find everything you need right here. Experience the blend of function and comfort at Chimneys Apts., where living is designed for your modern lifestyle in 79912.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
      "featured_image_media": {
        "alt_text": "The Chimney's Apartment Homes monument sign with phone number and landscaping.",
        "public_id": "019cfb3b-11b2-721d-8159-8503964fb8e9",
        "storage_key": "property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in 79912",
      "seo_description": "Find Chimneys Apts. in El Paso, 79912, offering apartments with dishwashers and premium amenities. The perfect choice for modern convenience seekers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "generator",
      "page_item_url": "chimneys-apts-walk-in-closets-el-paso-tx",
      "search_query": "walk-in closets apartments El Paso TX",
      "category": "Amenity",
      "h1_title": "Walk-In Closets Apartments in El Paso, TX",
      "h2_subtitle": "Discover the luxury of spacious living in walk-in closets apartments at Chimneys Apts., El Paso, TX. Style meets functionality here.",
      "page_copy": "At Chimneys Apts., located in the vibrant Festival Hills neighborhood of El Paso, TX, spacious living is redefined with our walk-in closets apartments. Our thoughtfully designed one- and two-bedroom units offer generous walk-in closets, providing ample storage and organizing space that transforms how you experience home living. \n\nThe elegance of Chimneys Apts. extends beyond our apartment interiors. Enjoy a wealth of community amenities, from a state-of-the-art fitness center to a refreshing sparkling pool, perfect for unwinding after a day in the bustling 79912 area. Our pet-friendly atmosphere, complete with a dedicated pet play area, welcomes all members of your family. Experience the perfect balance of style and comfort at Chimneys Apts. in El Paso, TX, where roomy walk-in closets are just the beginning of a luxurious lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
      "featured_image_media": {
        "alt_text": "The Chimney's Apartment Homes monument sign with phone number and landscaping.",
        "public_id": "019cfb3b-11b2-721d-8159-8503964fb8e9",
        "storage_key": "property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closets Apartments in El Paso, TX",
      "seo_description": "Live luxuriously at Chimneys Apts. in El Paso, TX, featuring spacious walk-in closets and premium amenities for the ideal lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "generator",
      "page_item_url": "chimneys-apts-1-bedroom-festival-hills-el-paso",
      "search_query": "1 bedroom apartments festival hills el paso",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Festival Hills, El Paso",
      "h2_subtitle": "Explore cozy 1 bedroom apartments in Festival Hills. Chimneys Apts. offers comfort in a prime El Paso location.",
      "page_copy": "Chimneys Apts. in Festival Hills is the ideal choice for those searching for charming 1 bedroom apartments in El Paso. Our thoughtfully designed spaces provide the perfect blend of comfort and practicality, featuring modern amenities such as walk-in closets and private balconies.\n\nNestled in the heart of the vibrant Festival Hills neighborhood, Chimneys Apts. offers more than just beautiful living spaces. Residents can enjoy a variety of community features, including a refreshing pool and a fully-equipped fitness center. Plus, our pet-friendly policy ensures that your furry friends will love living here too. Discover the convenience and charm of life at Chimneys Apts., where 1 bedroom apartments offer more than just a place to live, but a community to thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
      "featured_image_media": {
        "alt_text": "The Chimney's Apartment Homes monument sign with phone number and landscaping.",
        "public_id": "019cfb3b-11b2-721d-8159-8503964fb8e9",
        "storage_key": "property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Festival Hills, El Paso",
      "seo_description": "Find cozy 1 bedroom options at Chimneys Apts. in Festival Hills, El Paso. Enjoy comforts like walk-in closets and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165592",
      "source": "generator",
      "page_item_url": "chimneys-apts-2-bedroom-el-paso-79912",
      "search_query": "2 bedroom apartments el paso 79912",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in El Paso, 79912",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in El Paso, 79912 at Chimneys Apts. Enjoy a perfect blend of comfort and convenience.",
      "page_copy": "Discover the perfect home at Chimneys Apts., where our spacious 2 bedroom apartments in El Paso's 79912 zip code offer an exceptional living experience. Each apartment is designed to provide ample space with features like walk-in closets and charming balconies, creating a home that is both comfortable and stylish.\n\nLocated in the vibrant Festival Hills neighborhood, Chimneys Apts. combines in-home comfort with exciting community amenities. Enjoy a workout in our state-of-the-art fitness center or unwind by the sparkling pool. Our pet-friendly environment, complete with a pet play area, ensures all family members feel at home. Choose Chimneys Apts. for your next address and embrace a lifestyle of convenience and community in El Paso, 79912.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
      "featured_image_media": {
        "alt_text": "The Chimney's Apartment Homes monument sign with phone number and landscaping.",
        "public_id": "019cfb3b-11b2-721d-8159-8503964fb8e9",
        "storage_key": "property/6767906449165592/019cfb3b-11b2-721d-8159-8503964fb8e9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in El Paso, 79912",
      "seo_description": "Find spacious 2 bedroom homes at Chimneys Apts. in El Paso, 79912, offering modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5155"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-NVYD3ESCC5"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151828"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-chimneys-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KF3NBGCB"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165592/019d1bd7-6c70-735d-9a7d-ec53e00fcbc6.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "43dafd76-bc4c-4a1e-b385-edf2fec8e280"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-621-1573"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd438604c3418ec599fe"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1KallKc1d4WmkwdURuWkVhRnplK3c9PSIsInZhbHVlIjoiQU5BbDhJVlkrRXZXQ3I2Q2pkU3Fvdz09IiwibWFjIjoiOWI0NTkzNzZjYWQ1OTFlN2VhNGJkYjkzMTQ0M2RkZjYyMWU2YjkxZWQxOGU4YzU0ZTgwZjEyYTE0M2Y1ZDQxNSJ9"
    }
  ],
  "custom_qb_id": "5155",
  "custom_ga4_id": "G-NVYD3ESCC5",
  "custom_repli_id": "10041151828",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-chimneys-apartments/register/",
  "custom_google_gtm_id": "GTM-KF3NBGCB",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165592/019d1bd7-6c70-735d-9a7d-ec53e00fcbc6.pdf",
  "custom_rentgrata_property_id": "43dafd76-bc4c-4a1e-b385-edf2fec8e280",
  "custom_ppc_tracking_phone_number": "800-621-1573",
  "custom_residentboost_apartment_id": "6480cd438604c3418ec599fe",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1KallKc1d4WmkwdURuWkVhRnplK3c9PSIsInZhbHVlIjoiQU5BbDhJVlkrRXZXQ3I2Q2pkU3Fvdz09IiwibWFjIjoiOWI0NTkzNzZjYWQ1OTFlN2VhNGJkYjkzMTQ0M2RkZjYyMWU2YjkxZWQxOGU4YzU0ZTgwZjEyYTE0M2Y1ZDQxNSJ9"
};

export const generatedAt = '2026-08-27T21:39:09.673Z';
